export const CommonWordList = [
  {
    word: `and`,
    wordInfo: [
      `In rhythm, the second half of a divided beat.`,
      `Breath.`,
      `As a coordinating conjunction; expressing two elements to be taken together or in addition to each other.`,
    ],
  },
  {
    word: `of`,
    wordInfo: [`Expressing distance or motion.`, `To possess, own.`],
  },
  {
    word: `a`,
    wordInfo: [
      `The name of the Latin script letter A/a.`,
      `(crosswords) across`,
    ],
  },
  {
    word: `in`,
    wordInfo: [
      `A position of power or influence, or a way to get it.`,
      `To enclose.`,
      `Abbreviation of inch; inches.`,
    ],
  },
  {
    word: `to`,
    wordInfo: [
      `Toward a closed, touching or engaging position.`,
      `Indicating destination: In the direction of, and arriving at.`,
    ],
  },
  {
    word: `have`,
    wordInfo: [
      `A wealthy or privileged person.`,
      `A fraud or deception; something misleading.`,
      `To possess, own.`,
    ],
  },
  { word: `too`, wordInfo: [`(focus) Likewise.`] },
  {
    word: `it`,
    wordInfo: [
      `One who is neither a he nor a she; a creature; a dehumanized being.`,
      `Most fashionable.`,
      `A large peninsula in Southern Europe protruding into the Mediterranean Sea and shaped like a boot. The mountain range of Apennines runs across it from north to south. Occupied almost entirely by Italy.`,
      `A country in southern Europe. Official name: Italian Republic.`,
    ],
  },
  {
    word: `I`,
    wordInfo: [
      `The name of the Latin-script letter I.`,
      `The speaker or writer, referred to as the grammatical subject, of a sentence.`,
    ],
  },
  {
    word: `that`,
    wordInfo: [
      `Something being indicated that is there; one of those.`,
      `(degree) To a given extent or degree.`,
    ],
  },
  {
    word: `you`,
    wordInfo: [
      `To address (a person) using the pronoun you (in the past, especially to use you rather than thou, when you was considered more formal).`,
      `(object pronoun) The people spoken, or written to, as an object.`,
    ],
  },
  {
    word: `he`,
    wordInfo: [
      'The game of tag, or it, in which the player attempting to catch the others is called `he`.',
      `The name of the fifth letter of many Semitic alphabets (Phoenician, Aramaic, Hebrew, Syriac, Arabic and others).`,
      `(personal) A male person or animal already known or implied.`,
    ],
  },
  {
    word: `with`,
    wordInfo: [
      `Along, together with others, in a group, etc.`,
      `A flexible, slender twig or shoot, especially when used as a band or for binding; a withy.`,
      `Against.`,
    ],
  },
  {
    word: `on`,
    wordInfo: [
      `To switch on`,
      `In the state of being active, functioning or operating.`,
      `Without.`,
    ],
  },
  {
    word: `do`,
    wordInfo: [
      `A party, celebration, social function.`,
      `A syllable used in solf�ge to represent the first and eighth tonic of a major scale.`,
      `(auxiliary) A syntactic marker.`,
    ],
  },
  {
    word: `say`,
    wordInfo: [
      `A chance to speak; the right or power to influence or make a decision.`,
      `To pronounce.`,
      `A type of fine cloth similar to serge.`,
    ],
  },
  {
    word: `this`,
    wordInfo: [
      `Something being indicated that is here; one of these.`,
      `To the degree or extent indicated.`,
    ],
  },
  {
    word: `they`,
    wordInfo: [
      `(the third-person plural) A group of people, animals, plants or objects previously mentioned.`,
      `There (especially as an expletive subject of be).`,
    ],
  },
  {
    word: `at`,
    wordInfo: [
      `To reply to or talk to someone, either online or face-to-face. (from the practice of targeting a message or reply to someone online by writing @name)`,
      `The at sign (@).`,
      `Reduced form of that.`,
    ],
  },
  {
    word: `but`,
    wordInfo: [
      'An instance or example of using the word `but`.',
      'Use the word `but`.',
    ],
  },
  {
    word: `we`,
    wordInfo: [
      `(personal) The speakers/writers, or the speaker/writer and at least one other person (not the person being addressed). (This is the exclusive we.)`,
    ],
  },
  {
    word: `his`,
    wordInfo: [
      `Honorific alternative letter-case form of his, sometimes used when referring to God or another important figure who is understood from context.`,
      'The word `hi` used as a greeting.',
      `That which belongs to him; the possessive case of he, used without a following noun.`,
    ],
  },
  { word: `from`, wordInfo: [`Used to indicate source or provenance.`] },
  {
    word: `that`,
    wordInfo: [
      `Something being indicated that is there; one of those.`,
      `(degree) To a given extent or degree.`,
    ],
  },
  {
    word: `not`,
    wordInfo: [
      `A unary operation on logical values that changes true to false, and false to true.`,
      `Negates the meaning of the modified verb.`,
    ],
  },
  {
    word: `by`,
    wordInfo: [
      `A flying insect, of the clade Anthophila within the hymenopteran superfamily Apoidea, known for its organised societies (though only a minority have them), for collecting pollen and (in some species) producing wax and honey.`,
      `A contest, especially for spelling; see spelling bee.`,
    ],
  },
  {
    word: `she`,
    wordInfo: [
      `A female.`,
      `(personal) The female person or animal previously mentioned or implied.`,
    ],
  },
  {
    word: `or`,
    wordInfo: [
      'Connects at least two alternative words, phrases, clauses, sentences, etc. each of which could make a passage true. In English, this is the `inclusive or.` The `exclusive or` is formed by `either [...] or`.',
      `The binary operator inclusive or, true if one at least one of two inputs is true. In infix notation.`,
    ],
  },
  {
    word: `as`,
    wordInfo: [
      `To such an extent or degree; to the same extent or degree.`,
      `Introducing a basis of comparison, with an object in the objective case.`,
      `(unit of weight) A libra.`,
    ],
  },
  {
    word: `what`,
    wordInfo: [
      `(Singlish) Used to contradict an underlying assumption held by the interlocutor.`,
      `Something; thing; stuff.`,
    ],
  },
  {
    word: `go`,
    wordInfo: [
      `The act of going.`,
      `To move:`,
      `A strategic board game, originally from China, in which two players (black and white) attempt to control the largest area of the board with their counters.`,
    ],
  },
  {
    word: `can`,
    wordInfo: [
      `(auxiliary verb, defective) To know how to; to be able to.`,
      `A more or less cylindrical vessel for liquids, usually of steel or aluminium, but sometimes of plastic, and with a carrying handle over the top.`,
    ],
  },
  {
    word: `who`,
    wordInfo: [
      `A person under discussion; a question of which person.`,
      `(interrogative) What person or people; which person or people; asks for the identity of someone. (used in a direct or indirect question)`,
    ],
  },
  {
    word: `get`,
    wordInfo: [`Offspring.`, `A git.`, `(ditransitive) To obtain; to acquire.`],
  },
  {
    word: `if`,
    wordInfo: [
      `An uncertainty, possibility, condition, doubt etc.`,
      `Supposing that, assuming that, in the circumstances that; used to introduce a condition or choice.`,
    ],
  },
  {
    word: `would`,
    wordInfo: [
      `Something that would happen, or would be the case, under different circumstances; a potentiality.`,
    ],
  },
  {
    word: `her`,
    wordInfo: [
      `A female person or animal.`,
      `The form of she used after a preposition or as the object of a verb; that woman, that ship, etc.`,
    ],
  },
  {
    word: `all`,
    wordInfo: [
      `(with a possessive pronoun) Everything that one is capable of.`,
      `All gone; dead.`,
    ],
  },
  { word: `my`, wordInfo: [`Used to express surprise, shock or amazement.`] },
  {
    word: `make`,
    wordInfo: [
      `Brand or kind; model.`,
      `Mate; a spouse or companion; a match.`,
      `To create.`,
    ],
  },
  {
    word: `about`,
    wordInfo: [`Moving around; astir.`, `On all sides; around.`],
  },
  {
    word: `know`,
    wordInfo: [
      `Knowledge; the state of knowing.`,
      `To perceive the truth or factuality of; to be certain of or that.`,
    ],
  },
  {
    word: `will`,
    wordInfo: [
      `(now uncommon or literary) To wish, desire (something).`,
      `One's independent faculty of choice; the ability to be able to exercise one's choice or intention.`,
    ],
  },
  {
    word: `as`,
    wordInfo: [
      `To such an extent or degree; to the same extent or degree.`,
      `Introducing a basis of comparison, with an object in the objective case.`,
      `(unit of weight) A libra.`,
    ],
  },
  {
    word: `up`,
    wordInfo: [
      `The direction opposed to the pull of gravity.`,
      `To increase or raise.`,
    ],
  },
  {
    word: `one`,
    wordInfo: [
      `The digit or figure 1.`,
      `To cause to become one; to gather into a single whole; to unite.`,
    ],
  },
  {
    word: `time`,
    wordInfo: [
      `The inevitable progression into the future with the passing of present and past events.`,
      `To measure or record the time, duration, or rate of.`,
    ],
  },
  {
    word: `there`,
    wordInfo: [
      `That place.`,
      `(location) In a place or location (stated, implied or otherwise indicated) at some distance from the speaker (compare here).`,
    ],
  },
  {
    word: `year`,
    wordInfo: [
      `A solar year, the time it takes the Earth to complete one revolution of the Sun (between 365.24 and 365.26 days depending on the point of reference).`,
      `(abstract) This place; this location.`,
    ],
  },
  {
    word: `so`,
    wordInfo: [
      `True, accurate.`,
      `To the (explicitly stated) extent that.`,
      `Some person.`,
    ],
  },
  {
    word: `think`,
    wordInfo: [
      `An act of thinking; consideration (of something).`,
      `To seem, to appear.`,
      `To ponder, to go over in one's head.`,
    ],
  },
  {
    word: `when`,
    wordInfo: [
      `The time at which something happens.`,
      `(interrogative) At what time? At which time? Upon which occasion or circumstance? Used to introduce direct or indirect questions about time.`,
    ],
  },
  {
    word: `which`,
    wordInfo: [
      `(interrogative) What one or ones (of those mentioned or implied).`,
    ],
  },
  { word: `them`, wordInfo: [`(plural) Those ones.`] },
  {
    word: `some`,
    wordInfo: [
      `Of a measurement: approximately, roughly.`,
      `A certain number, at least two.`,
    ],
  },
  { word: `me`, wordInfo: [`As the direct object of a verb.`] },
  {
    word: `people`,
    wordInfo: [
      `Used as plural of person; a body of human beings considered generally or collectively; a group of two or more persons.`,
      `To stock with people or inhabitants; to fill as with people; to populate.`,
    ],
  },
  {
    word: `take`,
    wordInfo: [
      `The or an act of taking.`,
      `To get into one's hands, possession or control, with or without force.`,
    ],
  },
  {
    word: `out`,
    wordInfo: [
      `A means of exit, escape, reprieve, etc.`,
      `To eject; to expel.`,
    ],
  },
  { word: `into`, wordInfo: [`To or towards the inside of.`] },
  {
    word: `just`,
    wordInfo: [
      `Factually right, correct; factual.`,
      `Only, simply, merely.`,
      `A joust, tournament.`,
      `To joust, fight a tournament.`,
    ],
  },
  {
    word: `see`,
    wordInfo: [
      `(stative) To perceive or detect with the eyes, or as if by sight.`,
      `A diocese, archdiocese; a region of a church, generally headed by a bishop, especially an archbishop.`,
      `Directing the audience to pay attention to the following`,
    ],
  },
  {
    word: `him`,
    wordInfo: [
      `Honorific alternative letter-case form of him, sometimes used when referring to God or another important figure who is understood from context.`,
      `A male person.`,
    ],
  },

  {
    word: `could`,
    wordInfo: [
      `(auxiliary verb, defective) To know how to; to be able to.`,
      `Something that could happen, or could be the case, under different circumstances; a potentiality.`,
    ],
  },
  { word: `now`, wordInfo: [`The present time.`, `Present; current.`] },
  {
    word: `than`,
    wordInfo: [
      `At that time; then.`,
      `Introduces a comparison, and is associated with comparatives, and with words such as more, less, and fewer. Typically, it seeks to measure the force of an adjective or similar description between two predicates.`,
    ],
  },
  {
    word: `like`,
    wordInfo: [
      `(usually in the plural) Something that a person likes (prefers).`,
      `(sometimes as the likes of') Someone similar to a given person, or something similar to a given object; a comparative; a type; a sort.`,
      `To enjoy, be pleased by; favor; be in favor of.`,
      `Similar.`,
    ],
  },
  {
    word: `other`,
    wordInfo: [
      `An other, another (person, etc), more often rendered as another.`,
      'To regard, label or treat as an `other`, as not part of the same group; to view as different and alien.',
    ],
  },
  {
    word: `how`,
    wordInfo: [
      `The means by which something is accomplished.`,
      `To what degree.`,
      `An artificial barrow or tumulus.`,
    ],
  },
  {
    word: `then`,
    wordInfo: [
      `Used in comparisons, to introduce the basis of comparison.`,
      `That time`,
    ],
  },
  {
    word: `its`,
    wordInfo: [
      `One who is neither a he nor a she; a creature; a dehumanized being.`,
      `The one (or ones) belonging to it.`,
    ],
  },
  {
    word: `two`,
    wordInfo: [
      `The digit/figure 2.`,
      `A numerical value equal to 2; this many dots (��).`,
    ],
  },
  {
    word: `more`,
    wordInfo: [
      `To a greater degree or extent.`,
      `A carrot; a parsnip.`,
      `A greater number or quantity (of something).`,
    ],
  },
  { word: `these`, wordInfo: [`The thing, item, etc. being indicated.`] },
  {
    word: `want`,
    wordInfo: [
      `A desire, wish, longing.`,
      `To wish for or desire (something); to feel a need or desire for; to crave or demand.`,
    ],
  },
  {
    word: `way`,
    wordInfo: [
      `(heading) To do with a place or places.`,
      `To travel.`,
      `(with comparative or modified adjective) Much.`,
    ],
  },
  {
    word: `first`,
    wordInfo: [
      `The person or thing in the first position.`,
      `Preceding all others of a series or kind; the ordinal of one; earliest.`,
      `Time; time granted; respite.`,
    ],
  },
  {
    word: `also`,
    wordInfo: [`(focus) In addition; besides; as well; further; too.`],
  },
  {
    word: `new`,
    wordInfo: [`Things that are new.`, `To make new; to recreate; to renew.`],
  },
  {
    word: `because`,
    wordInfo: [`For the reason (that).`, `On account of, because of.`],
  },
  {
    word: `day`,
    wordInfo: [`Any period of 24 hours.`, `To spend a day (in a place).`],
  },
  {
    word: `more`,
    wordInfo: [
      `To a greater degree or extent.`,
      `A carrot; a parsnip.`,
      `A greater number or quantity (of something).`,
    ],
  },
  { word: `use`, wordInfo: [`The act of using.`, `To utilize or employ.`] },
  {
    word: `no`,
    wordInfo: [
      `A negating expression; an answer that shows disagreement or disapproval`,
      `(now only used with different, with comparatives more and less, and informally with certain other adjectives such as good and fun) Not, not at all.`,
      `At or towards the interior of a defined space, such as a building or room.`,
      `An abstract entity used to describe quantity.`,
    ],
  },
  {
    word: `man`,
    wordInfo: [
      `An adult male human.`,
      `To supply (something) with staff or crew (of either sex).`,
      `Used to place emphasis upon something or someone; sometimes, but not always, when actually addressing a man.`,
    ],
  },
  {
    word: `find`,
    wordInfo: [
      `Anything that is found (usually valuable), as objects on an archeological site or a person with talent.`,
      `To encounter or discover by accident; to happen upon.`,
    ],
  },
  {
    word: `here`,
    wordInfo: [
      `(abstract) This place; this location.`,
      `Filler after a noun or demonstrative pronoun, solely for emphasis.`,
    ],
  },
  {
    word: `thing`,
    wordInfo: [
      `That which is considered to exist as a separate entity, object, quality or concept.`,
      `To express as a thing; to reify.`,
    ],
  },
  {
    word: `give`,
    wordInfo: [
      `The amount of bending that something undergoes when a force is applied to it; a tendency to yield under pressure; resilence.`,
      `A shackle or fetter, especially for the leg.`,
      `(ditransitive) To move, shift, provide something abstract or concrete to someone or something or somewhere.`,
    ],
  },
  {
    word: `many`,
    wordInfo: [
      `A multitude; a great aggregate; a mass of people; the generality; the common herd.`,
      `A large number of; numerous.`,
    ],
  },
  {
    word: `well`,
    wordInfo: [
      `In good health.`,
      `(manner) Accurately, competently, satisfactorily.`,
      `A hole sunk into the ground as a source of water, oil, natural gas or other fluids.`,
    ],
  },
  { word: `only`, wordInfo: [`An only child.`, `Alone in a category.`] },
  {
    word: `those`,
    wordInfo: [
      '(demonstrative) The thing, person, idea, quality, event, action or time indicated or understood from context, especially if more remote geographically, temporally or mentally than one designated as `this`, or if expressing distinction.',
    ],
  },
  {
    word: `tell`,
    wordInfo: [
      `A reflexive, often habitual behavior, especially one occurring in a context that often features attempts at deception by persons under psychological stress (such as a poker game or police interrogation), that reveals information that the person exhibiting the behavior is attempting to withhold.`,
      `A hill or mound, originally and especially in the Middle East, over or consisting of the ruins of ancient settlements.`,
      `(archaic outside of idioms) To count, reckon, or enumerate.`,
    ],
  },
  {
    word: `one`,
    wordInfo: [
      `The digit or figure 1.`,
      `To cause to become one; to gather into a single whole; to unite.`,
    ],
  },
  {
    word: `very`,
    wordInfo: [`True, real, actual.`, `To a great extent or degree.`],
  },
  {
    word: `her`,
    wordInfo: [
      `A female person or animal.`,
      `The form of she used after a preposition or as the object of a verb; that woman, that ship, etc.`,
    ],
  },
  {
    word: `even`,
    wordInfo: [
      `(diminutive) An even number.`,
      `To make flat and level.`,
      `Evening.`,
    ],
  },
  {
    word: `back`,
    wordInfo: [
      `The rear of the body, especially the part between the neck and the end of the spine and opposite the chest and belly.`,
      `To go in the reverse direction.`,
      `A large shallow vat; a cistern, tub, or trough, used by brewers, distillers, dyers, picklers, gluemakers, and others, for mixing or cooling wort, holding water, hot glue, etc.`,
    ],
  },
  {
    word: `any`,
    wordInfo: [
      `To even the slightest extent, at all.`,
      `Any thing(s) or person(s).`,
    ],
  },
  {
    word: `good`,
    wordInfo: [
      `(of people)`,
      `Well; satisfactorily or thoroughly.`,
      `That is good; an elliptical exclamation of satisfaction or commendation.`,
    ],
  },
  {
    word: `woman`,
    wordInfo: [`An adult female human.`, `To staff with female labor.`],
  },
  {
    word: `through`,
    wordInfo: [
      `A large slab of stone laid in a dry-stone wall from one side to the other; a perpend.`,
      `Passing from one side of something to the other.`,
      `A coffin, sarcophagus or tomb of stone; a large slab of stone laid on a tomb.`,
    ],
  },
  {
    word: `us`,
    wordInfo: [
      `(personal) Me and at least one other person; the objective case of we.`,
    ],
  },
  {
    word: `life`,
    wordInfo: [
      `The state of organisms preceding their death, characterized by biological processes such as metabolism and reproduction and distinguishing them from inanimate objects; the state of being alive and living.`,
    ],
  },
  {
    word: `child`,
    wordInfo: [
      `A person who has not yet reached adulthood, whether natural (puberty), cultural (initiation), or legal (majority)`,
      `To give birth; to beget or procreate.`,
      `A child of noble birth.`,
    ],
  },
  {
    word: `there`,
    wordInfo: [
      `That place.`,
      `(location) In a place or location (stated, implied or otherwise indicated) at some distance from the speaker (compare here).`,
    ],
  },
  {
    word: `work`,
    wordInfo: [
      `(heading) Employment.`,
      `To do a specific task by employing physical or mental powers.`,
    ],
  },
  {
    word: `down`,
    wordInfo: [
      `A negative aspect; a downer.`,
      `To knock (someone or something) down; to cause to come down, to fell.`,
      `(especially southern England) A hill, especially a chalk hill; rolling grassland`,
    ],
  },
  {
    word: `may`,
    wordInfo: [
      `To be strong; to have power (over).`,
      `The hawthorn bush or its blossoms.`,
    ],
  },
  {
    word: `after`,
    wordInfo: [
      `Later; second (of two); next, following, subsequent`,
      `Behind; later in time; following.`,
    ],
  },
  {
    word: `should`,
    wordInfo: [
      `(modal, auxiliary verb, defective) Used before a verb to indicate the simple future tense in the first person singular or plural.`,
      `A statement of what ought to be the case as opposed to what is the case.`,
    ],
  },
  {
    word: `call`,
    wordInfo: [`A telephone conversation.`, `(heading) To use one's voice.`],
  },
  {
    word: `world`,
    wordInfo: [
      '(with `the`) Human collective existence; existence in general.',
      `To consider or cause to be considered from a global perspective; to consider as a global whole, rather than making or focussing on national or other distinctions; compare globalise.`,
    ],
  },
  {
    word: `over`,
    wordInfo: [
      `A set of six legal balls bowled.`,
      `To go over, or jump over.`,
      `A shore, riverbank.`,
    ],
  },
  {
    word: `school`,
    wordInfo: [
      `(collective) A group of fish or a group of marine mammals such as porpoises, dolphins, or whales.`,
      `An institution dedicated to teaching and learning; an educational institution.`,
      `(of fish) To form into, or travel in a school.`,
      `To educate, teach, or train (often, but not necessarily, in a school).`,
    ],
  },
  {
    word: `still`,
    wordInfo: [
      `A period of calm or silence.`,
      `Not moving; calm.`,
      `A device for distilling liquids.`,
    ],
  },
  {
    word: `try`,
    wordInfo: [
      `An attempt.`,
      `Fine, excellent.`,
      `To attempt; to endeavour. Followed by infinitive.`,
    ],
  },
  {
    word: `in`,
    wordInfo: [
      `A position of power or influence, or a way to get it.`,
      `To enclose.`,
      `Abbreviation of inch; inches.`,
    ],
  },
  {
    word: `as`,
    wordInfo: [
      `To such an extent or degree; to the same extent or degree.`,
      `Introducing a basis of comparison, with an object in the objective case.`,
      `(unit of weight) A libra.`,
    ],
  },
  {
    word: `last`,
    wordInfo: [
      `Final, ultimate, coming after all others of its kind.`,
      `To perform, carry out.`,
      `Most recently.`,
    ],
  },
  {
    word: `ask`,
    wordInfo: [
      `An act or instance of asking.`,
      `An eft; newt.`,
      `To request (information, or an answer to a question).`,
    ],
  },
  {
    word: `need`,
    wordInfo: [
      `A requirement for something; something needed.`,
      `To have an absolute requirement for.`,
    ],
  },
  { word: `too`, wordInfo: [`(focus) Likewise.`] },
  {
    word: `feel`,
    wordInfo: [
      `A quality of an object experienced by touch.`,
      `Much; many.`,
      `(heading) To use or experience the sense of touch.`,
      `Greatly, much, very`,
    ],
  },
  {
    word: `three`,
    wordInfo: [
      `The digit/figure 3.`,
      `A numerical value after two and before four. Represented in Arabic digits as 3; this many dots (���).`,
    ],
  },
  {
    word: `when`,
    wordInfo: [
      `The time at which something happens.`,
      `(interrogative) At what time? At which time? Upon which occasion or circumstance? Used to introduce direct or indirect questions about time.`,
    ],
  },
  {
    word: `state`,
    wordInfo: [
      `A condition; a set of circumstances applying at any given time.`,
      `To declare to be a fact.`,
    ],
  },
  {
    word: `never`,
    wordInfo: [`At no time; on no occasion; in no circumstance.`],
  },
  { word: `become`, wordInfo: [`To arrive, come (to a place).`] },
  {
    word: `between`,
    wordInfo: [
      `A kind of needle, shorter than a sharp, with a small rounded eye, used for making fine stitches on heavy fabrics.`,
      `In the position or interval that separates (two things), or intermediate in quantity or degree. (See Usage notes below.)`,
    ],
  },
  {
    word: `high`,
    wordInfo: [
      `A high point or position, literally or figuratively; an elevated place; a superior region; a height; the sky; heaven.`,
      `To rise.`,
      `Thought; intention; determination; purpose.`,
    ],
  },
  {
    word: `really`,
    wordInfo: [
      `In a way or manner that is real, not unreal.`,
      `To bring together again.`,
      `Indicating surprise at, or requesting confirmation of, some new information; to express skepticism.`,
    ],
  },
  {
    word: `something`,
    wordInfo: [
      `An object whose nature is yet to be defined.`,
      `Applied to an action whose name is forgotten by, unknown or unimportant to the user, e.g. from words of a song.`,
    ],
  },
  {
    word: `most`,
    wordInfo: [
      `The greatest amount.`,
      `Forms the superlative of many adjectives.`,
      `Almost.`,
    ],
  },
  { word: `another`, wordInfo: [`An additional one of the same kind.`] },
  { word: `much`, wordInfo: [`Large, great.`, `To a great extent.`] },
  {
    word: `family`,
    wordInfo: [
      `A group of people who are closely related to one another (by blood, marriage or adoption); kin; for example, a set of parents and their children; an immediate family.`,
      `Suitable for children and adults.`,
    ],
  },
  {
    word: `own`,
    wordInfo: [
      `Belonging to; possessed; proper to. Often marks a possessive determiner as reflexive, referring back to the subject of the clause or sentence.`,
      `To have rightful possession of (property, goods or capital); to have legal title to.`,
    ],
  },
  {
    word: `out`,
    wordInfo: [
      `A means of exit, escape, reprieve, etc.`,
      `To eject; to expel.`,
    ],
  },
  {
    word: `leave`,
    wordInfo: [
      `To have a consequence or remnant.`,
      `The action of the batsman not attempting to play at the ball.`,
    ],
  },
  {
    word: `put`,
    wordInfo: [
      `A right to sell something at a predetermined price.`,
      `An idiot; a foolish person; a duffer.`,
      `To place something somewhere.`,
    ],
  },
  {
    word: `old`,
    wordInfo: [
      `(with the, invariable plural only) People who are old; old beings; the older generation, taken as a group.`,
      `Of an object, concept, relationship, etc., having existed for a relatively long period of time.`,
    ],
  },
  {
    word: `while`,
    wordInfo: [
      `An uncertain duration of time, a period of time.`,
      `To pass (time) idly.`,
    ],
  },
  { word: `mean`, wordInfo: [`To lament.`, `Common; general.`, `To intend.`] },
  {
    word: `on`,
    wordInfo: [
      `To switch on`,
      `In the state of being active, functioning or operating.`,
      `Without.`,
    ],
  },
  {
    word: `keep`,
    wordInfo: [
      `The main tower of a castle or fortress, located within the castle walls.`,
      `To continue in (a course or mode of action); not to intermit or fall from; to uphold or maintain.`,
    ],
  },
  {
    word: `student`,
    wordInfo: [`A person who studies or learns about a particular subject.`],
  },
  {
    word: `why`,
    wordInfo: [
      `Reason`,
      `For what cause, reason, or purpose (interrogative adverb).`,
      `A young heifer.`,
    ],
  },
  {
    word: `let`,
    wordInfo: [
      `The allowing of possession of a property etc. in exchange for rent.`,
      `To allow to, not to prevent (+ infinitive, but usually without to).`,
      `To allow to, not to prevent (+ infinitive, but usually without to).`,
      `An obstacle or hindrance.`,
    ],
  },
  {
    word: `great`,
    wordInfo: [
      `A person of major significance, accomplishment or acclaim.`,
      `Relatively large in scale, size, extent, number (i.e. having many parts or members) or duration (i.e. relatively long); very big.`,
    ],
  },
  {
    word: `same`,
    wordInfo: [
      `Not different or other; not another or others; not different as regards self; selfsame; identical.`,
      `The identical thing, ditto.`,
      `Together.`,
    ],
  },
  {
    word: `big`,
    wordInfo: [
      `Someone or something that is large in stature`,
      `To praise, recommend, or promote.`,
      `To inhabit; occupy`,
    ],
  },
  {
    word: `group`,
    wordInfo: [
      `A number of things or persons being in some relation to one another.`,
      `To put together to form a group.`,
    ],
  },
  {
    word: `begin`,
    wordInfo: [
      `Beginning; start.`,
      `To start, to initiate or take the first step into something.`,
    ],
  },
  {
    word: `seem`,
    wordInfo: [`To appear; to look outwardly; to be perceived as.`],
  },
  {
    word: `country`,
    wordInfo: [
      `(chiefly British) An area of land; a district, region.`,
      `From or in the countryside or connected with it.`,
    ],
  },
  {
    word: `help`,
    wordInfo: [
      `Action given to provide assistance; aid.`,
      `To provide assistance to (someone or something).`,
    ],
  },
  {
    word: `talk`,
    wordInfo: [
      `To communicate, usually by means of speech.`,
      `A conversation or discussion; usually serious, but informal.`,
    ],
  },
  {
    word: `where`,
    wordInfo: [
      `The place in which something happens.`,
      `Interrogative adverb, used in either a direct or indirect question: at what place; to what place; what place.`,
    ],
  },
  {
    word: `turn`,
    wordInfo: [
      `(heading) to make a non-linear physical movement.`,
      `A change of direction or orientation.`,
    ],
  },
  {
    word: `problem`,
    wordInfo: [
      `A difficulty that has to be resolved or dealt with.`,
      `(of a person or an animal) Difficult to train or guide; unruly.`,
    ],
  },
  {
    word: `start`,
    wordInfo: [
      `The beginning of an activity.`,
      `To begin, commence, initiate.`,
    ],
  },
  {
    word: `hand`,
    wordInfo: [
      `The part of the forelimb below the forearm or wrist in a human, and the corresponding part in many other animals.`,
      `To give, pass, or transmit with the hand, literally or figuratively.`,
    ],
  },
  {
    word: `might`,
    wordInfo: [
      `Power, strength, force or influence held by a person or group.`,
      `To be strong; to have power (over).`,
      `Mighty; powerful.`,
      `(auxiliary) Used to indicate conditional or possible actions.`,
    ],
  },
  {
    word: `show`,
    wordInfo: [
      `A play, dance, or other entertainment.`,
      `To display, to have somebody see (something).`,
    ],
  },
  {
    word: `part`,
    wordInfo: [`A portion; a component.`, `To leave the company of.`],
  },
  {
    word: `about`,
    wordInfo: [`Moving around; astir.`, `On all sides; around.`],
  },
  {
    word: `against`,
    wordInfo: [
      `In a contrary direction to.`,
      `By the time that (something happened); before.`,
    ],
  },
  {
    word: `place`,
    wordInfo: [
      `(physical) An area; somewhere within an area.`,
      `To put (an object or person) in a specific location.`,
    ],
  },
  {
    word: `over`,
    wordInfo: [
      `A set of six legal balls bowled.`,
      `To go over, or jump over.`,
      `A shore, riverbank.`,
    ],
  },
  {
    word: `such`,
    wordInfo: [
      `Something being indicated that is similar to something else.`,
      `A person, a thing, people or things like the one or ones already mentioned.`,
    ],
  },
  {
    word: `again`,
    wordInfo: [`Another time; once more.`, `(obsolete or dialectal) Against.`],
  },
  { word: `few`, wordInfo: [`Few people, few things.`] },
  {
    word: `case`,
    wordInfo: [
      `An actual event, situation, or fact.`,
      `A box that contains or can contain a number of identical items of manufacture.`,
      `To propose hypothetical cases.`,
      `To place (an item or items of manufacture) into a box, as in preparation for shipment.`,
    ],
  },
  {
    word: `most`,
    wordInfo: [
      `The greatest amount.`,
      `Forms the superlative of many adjectives.`,
      `Almost.`,
    ],
  },
  { word: `week`, wordInfo: [`Any period of seven consecutive days.`] },
  {
    word: `company`,
    wordInfo: [
      `A team; a group of people who work together professionally.`,
      `To accompany, keep company with.`,
    ],
  },
  {
    word: `where`,
    wordInfo: [
      `The place in which something happens.`,
      `Interrogative adverb, used in either a direct or indirect question: at what place; to what place; what place.`,
    ],
  },
  {
    word: `system`,
    wordInfo: [
      `A collection of organized things; a whole composed of relationships among its members.`,
    ],
  },
  {
    word: `each`,
    wordInfo: [
      `(operations) An individual item: the least quantitative unit in a grouping.`,
      `For one; apiece; per.`,
    ],
  },
  { word: `right`, wordInfo: [`Straight, not bent.`, `On the right side.`] },
  {
    word: `program`,
    wordInfo: [
      `A set of structured activities.`,
      `To enter a program or other instructions into (a computer or other electronic device) to instruct it to do a particular task.`,
    ],
  },
  { word: `hear`, wordInfo: [`(stative) To perceive sounds through the ear.`] },
  {
    word: `so`,
    wordInfo: [
      `True, accurate.`,
      `To the (explicitly stated) extent that.`,
      `Some person.`,
    ],
  },
  {
    word: `question`,
    wordInfo: [
      `A sentence, phrase or word which asks for information, reply or response; an interrogative.`,
      `To ask questions about; to interrogate; to enquire for information.`,
    ],
  },
  {
    word: `during`,
    wordInfo: [
      `To last, continue, endure.`,
      `For all of a given time interval.`,
    ],
  },
  {
    word: `work`,
    wordInfo: [
      `(heading) Employment.`,
      `To do a specific task by employing physical or mental powers.`,
    ],
  },
  {
    word: `play`,
    wordInfo: [
      `Activity for amusement only, especially among the young.`,
      `To act in a manner such that one has fun; to engage in activities expressly for the purpose of recreation or entertainment.`,
    ],
  },
  {
    word: `government`,
    wordInfo: [
      `The body with the power to make and/or enforce laws to control a country, land area, people or organization.`,
    ],
  },
  {
    word: `run`,
    wordInfo: [
      `To run.`,
      `Act or instance of running, of moving rapidly using the feet.`,
    ],
  },
  {
    word: `small`,
    wordInfo: [
      `Any part of something that is smaller or slimmer than the rest, now usually with anatomical reference to the back.`,
      `To make little or less.`,
    ],
  },
  {
    word: `number`,
    wordInfo: [
      `An abstract entity used to describe quantity.`,
      `Physically unable to feel, not having the power of sensation.`,
      `To label (items) with numbers; to assign numbers to (items).`,
    ],
  },
  {
    word: `off`,
    wordInfo: [
      `(usually in phrases such as 'from the off', 'at the off', etc.) Beginning; starting point.`,
      `To kill.`,
    ],
  },
  {
    word: `always`,
    wordInfo: [`At all times; throughout all time; since the beginning.`],
  },
  {
    word: `move`,
    wordInfo: [
      `The act of moving; a movement.`,
      `To change place or posture; to go, in any manner, from one place or position to another.`,
    ],
  },
  {
    word: `like`,
    wordInfo: [
      `(usually in the plural) Something that a person likes (prefers).`,
      `(sometimes as the likes of') Someone similar to a given person, or something similar to a given object; a comparative; a type; a sort.`,
      `To enjoy, be pleased by; favor; be in favor of.`,
      `Similar.`,
    ],
  },
  {
    word: `night`,
    wordInfo: [
      `The period between sunset and sunrise, when a location faces far away from the sun, thus when the sky is dark.`,
      `To spend a night (in a place), to overnight.`,
    ],
  },
  { word: `live`, wordInfo: [`To be alive; to have life.`, `Life`] },
  {
    word: `point`,
    wordInfo: [
      `A discrete division of something.`,
      `To extend the index finger in the direction of something in order to show where it is or to draw attention to it.`,
    ],
  },
  {
    word: `believe`,
    wordInfo: [
      `To accept as true, particularly without absolute certainty (i.e., as opposed to knowing)`,
    ],
  },
  {
    word: `hold`,
    wordInfo: [
      `A grasp or grip.`,
      `The cargo area of a ship or aircraft (often holds or cargo hold).`,
      `To grasp or grip.`,
    ],
  },
  {
    word: `today`,
    wordInfo: [`A current day or date.`, `On the current day or date.`],
  },
  {
    word: `bring`,
    wordInfo: [
      `(ditransitive) To transport toward somebody/somewhere.`,
      `The sound of a telephone ringing.`,
    ],
  },
  { word: `happen`, wordInfo: [`To occur or take place.`, `Maybe, perhaps.`] },
  {
    word: `next`,
    wordInfo: [
      `The one that follows after this one.`,
      `Nearest in place or position, having nothing similar intervening; adjoining.`,
    ],
  },
  {
    word: `without`,
    wordInfo: [
      `Outside, externally. This is still used in the names of some civil parishes in England, e.g. St Cuthbert Without.`,
      `Outside of, beyond.`,
    ],
  },
  {
    word: `before`,
    wordInfo: [`At an earlier time.`, `Earlier than (in time).`],
  },
  {
    word: `large`,
    wordInfo: [
      `An old musical note, equal to two longas, four breves, or eight semibreves.`,
      `Of considerable or relatively great size or extent.`,
    ],
  },
  {
    word: `all`,
    wordInfo: [
      `(with a possessive pronoun) Everything that one is capable of.`,
      `All gone; dead.`,
    ],
  },
  {
    word: `million`,
    wordInfo: [
      `(long and short scales) The cardinal number 1,000,000: 106; a thousand thousand.`,
    ],
  },
  {
    word: `must`,
    wordInfo: [
      `Something that is mandatory or required.`,
      `The property of being stale or musty.`,
      `(modal auxiliary, defective) To do with certainty; indicates that the speaker is certain that the subject will have executed the predicate.`,
      `To make musty.`,
    ],
  },
  {
    word: `home`,
    wordInfo: [`A dwelling.`, `(of animals) To return to its owner.`],
  },
  {
    word: `under`,
    wordInfo: [
      `Being lower; being beneath something.`,
      `In a way lower or less than.`,
    ],
  },

  {
    word: `room`,
    wordInfo: [
      `Opportunity or scope (to do something).`,
      `Wide; spacious; roomy.`,
      `To reside, especially as a boarder or tenant.`,
    ],
  },
  {
    word: `write`,
    wordInfo: [
      `The act or style of writing.`,
      `To form letters, words or symbols on a surface in order to communicate.`,
    ],
  },
  {
    word: `mother`,
    wordInfo: [
      `A (human) female who has given birth to a baby`,
      `To give birth to or produce (as its female parent) a child. (Compare father.)`,
    ],
  },
  {
    word: `area`,
    wordInfo: [
      `A measure of the extent of a surface; it is measured in square units.`,
    ],
  },
  {
    word: `national`,
    wordInfo: [`A subject of a nation.`, `Of or having to do with a nation.`],
  },
  {
    word: `money`,
    wordInfo: [
      `A legally or socially binding conceptual contract of entitlement to wealth, void of intrinsic value, payable for all debts and taxes, and regulated in supply.`,
    ],
  },
  {
    word: `story`,
    wordInfo: [
      `A sequence of real or fictional events; or, an account of such a sequence.`,
      `A building; an edifice.`,
      `To tell as a story; to relate or narrate about.`,
      `A building or edifice.`,
    ],
  },
  {
    word: `young`,
    wordInfo: [
      `People who are young; young people, collectively; youth.`,
      `To become or seem to become younger.`,
    ],
  },
  {
    word: `fact`,
    wordInfo: [
      `Something actual as opposed to invented.`,
      `Used before making a statement to introduce it as a trustworthy one.`,
    ],
  },
  {
    word: `month`,
    wordInfo: [
      `A period into which a year is divided, historically based on the phases of the moon.`,
    ],
  },
  {
    word: `different`,
    wordInfo: [
      `The different ideal.`,
      `Not the same; exhibiting a difference.`,
    ],
  },
  {
    word: `lot`,
    wordInfo: [
      `A large quantity or number; a great deal.`,
      `To allot; to sort; to apportion.`,
    ],
  },
  { word: `right`, wordInfo: [`Straight, not bent.`, `On the right side.`] },
  {
    word: `study`,
    wordInfo: [
      `(usually academic) To review materials already learned in order to make sure one does not forget them, usually in preparation for an examination.`,
      `Mental effort to acquire knowledge or learning.`,
    ],
  },
  {
    word: `book`,
    wordInfo: [
      `A collection of sheets of paper bound together to hinge at one edge, containing printed or written material, pictures, etc.`,
      `To reserve (something) for future use.`,
    ],
  },
  {
    word: `eye`,
    wordInfo: [
      `An organ through which animals see (perceive surroundings via light).`,
      `A brood.`,
      `To observe carefully or appraisingly.`,
    ],
  },
  {
    word: `job`,
    wordInfo: [`A task.`, `To do odd jobs or occasional work for hire.`],
  },
  {
    word: `word`,
    wordInfo: [
      `The smallest unit of language that has a particular meaning and can be expressed by itself; the smallest discrete, meaningful unit of language. (contrast morpheme.)`,
      `To say or write (something) using particular words; to phrase (something).`,
      `(except in set phrases) To be, become, betide.`,
    ],
  },
  {
    word: `though`,
    wordInfo: [`Despite that; however.`, `Despite the fact that; although.`],
  },
  {
    word: `business`,
    wordInfo: [
      `A specific commercial enterprise or establishment.`,
      `Of, to, pertaining to or utilized for purposes of conducting trade, commerce, governance, advocacy or other professional purposes.`,
    ],
  },
  {
    word: `issue`,
    wordInfo: [
      `The action or an instance of flowing or coming out, an outflow, particularly:`,
      `To flow out, to proceed from, to come out or from.`,
    ],
  },
  {
    word: `side`,
    wordInfo: [
      `A bounding straight edge of a two-dimensional shape.`,
      'To ally oneself, be in an alliance, usually with `with` or rarely `in with`',
      `To clear, tidy or sort.`,
      `Wide; large; long, pendulous, hanging low, trailing; far-reaching.`,
    ],
  },
  {
    word: `kind`,
    wordInfo: [
      `A type, race or category; a group of entities that have common characteristics such that they may be grouped together.`,
      `Having a benevolent, courteous, friendly, generous, gentle, liberal, sympathetic, or warm-hearted nature or disposition, marked by consideration for � and service to � others.`,
    ],
  },
  {
    word: `four`,
    wordInfo: [
      `The digit or figure 4; an occurrence thereof.`,
      `A numerical value equal to 4; the number after three and before five; two plus two. This many dots (����)`,
    ],
  },
  {
    word: `head`,
    wordInfo: [
      `The part of the body of an animal or human which contains the brain, mouth and main sense organs.`,
      `To be in command of. (See also head up.)`,
      `Foremost in rank or importance.`,
    ],
  },
  {
    word: `far`,
    wordInfo: [
      `Distant; remote in space.`,
      `Spelt (a type of wheat, Triticum spelta), especially in the context of Roman use of it.`,
      `To, from or over a great distance in space, time or other extent.`,
    ],
  },
  {
    word: `black`,
    wordInfo: [
      `The colour/color perceived in the absence of light, but also when no light is reflected, but rather absorbed.`,
      `To make black; to blacken.`,
    ],
  },
  {
    word: `long`,
    wordInfo: [
      `A long vowel.`,
      `To take a long position in.`,
      `Over a great distance in space.`,
    ],
  },
  {
    word: `both`,
    wordInfo: [
      `Each of the two, or of the two kinds.`,
      `Including both of (used with and).`,
    ],
  },
  { word: `little`, wordInfo: [`A small amount.`, `Small in size.`] },
  {
    word: `house`,
    wordInfo: [
      `A structure built or serving as an abode of human beings.`,
      `To keep within a structure or container.`,
    ],
  },
  {
    word: `yes`,
    wordInfo: [
      `An affirmative expression; an answer that shows agreement or acceptance.`,
      `To agree with, affirm, approve.`,
    ],
  },
  {
    word: `after`,
    wordInfo: [
      `Later; second (of two); next, following, subsequent`,
      `Behind; later in time; following.`,
    ],
  },
  {
    word: `since`,
    wordInfo: [
      `From a specified time in the past.`,
      `From: referring to a period of time ending in the present and defining it by the point in time at which it started, or the period in which its starting point occurred.`,
    ],
  },
  {
    word: `long`,
    wordInfo: [
      `A long vowel.`,
      `To take a long position in.`,
      `Over a great distance in space.`,
    ],
  },
  {
    word: `provide`,
    wordInfo: [`To make a living; earn money for necessities.`],
  },
  {
    word: `service`,
    wordInfo: [
      `An act of being of assistance to someone.`,
      `Service tree`,
      `To serve.`,
    ],
  },
  {
    word: `around`,
    wordInfo: [
      '(with the verb `to be`) Present in the vicinity.',
      `So as to form a circle or trace a circular path, or approximation thereof.`,
    ],
  },
  {
    word: `friend`,
    wordInfo: [
      `A person other than a family member, spouse or lover whose company one enjoys and towards whom one feels affection.`,
      `To act as a friend to, to befriend; to be friendly to, to help.`,
    ],
  },
  { word: `important`, wordInfo: [`Having relevant and crucial value.`] },
  {
    word: `father`,
    wordInfo: [
      `A (generally human) male who begets a child.`,
      `To be a father to; to sire.`,
    ],
  },
  {
    word: `sit`,
    wordInfo: [
      `Subsidence of the roof of a coal mine.`,
      `Short for situation.`,
      `(of a person) To be in a position in which the upper body is upright and supported by the buttocks.`,
    ],
  },
  {
    word: `away`,
    wordInfo: [
      `To depart; to go to another place.`,
      `Not here, gone, absent, unavailable, traveling; on vacation.`,
    ],
  },
  {
    word: `until`,
    wordInfo: [
      `Up to the time of (something happening).`,
      `Up to the time that (a condition becomes true).`,
    ],
  },
  {
    word: `power`,
    wordInfo: [
      `Ability to do or undergo something.`,
      `To provide power for (a mechanical or electronic device).`,
    ],
  },
  {
    word: `hour`,
    wordInfo: [`A time period of sixty minutes; one twenty-fourth of a day.`],
  },
  {
    word: `game`,
    wordInfo: [`A playful or competitive activity.`, `To gamble.`],
  },
  { word: `often`, wordInfo: [`Frequent.`, `Frequently, many times.`] },
  {
    word: `yet`,
    wordInfo: [
      `(usually with negative) Thus far; up to the present; up to some specified time; still`,
      `A metal pan or boiler; yetling.`,
      `Nevertheless; however; but; despite that.`,
      `To melt; found; cast, as metal.`,
    ],
  },
  {
    word: `line`,
    wordInfo: [
      `A path through two or more points (compare �segment�); a continuous mark, including as made by a pen; any path, curved or straight.`,
      `Flax; linen, particularly the longer fiber of flax.`,
      'To place (objects) into a line (usually used with `up`); to form into a line; to align.',
      `To cover the inner surface of (something), originally especially with linen.`,
    ],
  },
  {
    word: `political`,
    wordInfo: [
      `A political agent or officer.`,
      `Concerning or relating to politics, the art and process of governing.`,
    ],
  },
  {
    word: `end`,
    wordInfo: [
      `The terminal point of something in space or time.`,
      `To come to an end`,
    ],
  },
  {
    word: `among`,
    wordInfo: [
      `Denotes a mingling or intermixing with distinct or separable objects. (See Usage Note at amidst.)`,
    ],
  },
  {
    word: `ever`,
    wordInfo: [
      `Occurring at any time, occurring even but once during a timespan.`,
      `Always, frequently, forever.`,
    ],
  },
  {
    word: `stand`,
    wordInfo: [
      `The act of standing.`,
      `(heading) To position or be positioned physically.`,
    ],
  },
  {
    word: `bad`,
    wordInfo: [
      `Error, mistake.`,
      `Unfavorable; negative; not good.`,
      `Fantastic.`,
    ],
  },
  {
    word: `lose`,
    wordInfo: [
      `To cause (something) to cease to be in one's possession or capability due to unfortunate or unknown circumstances, events or reasons.`,
      `Fame, renown; praise.`,
    ],
  },
  {
    word: `however`,
    wordInfo: [
      `Nevertheless; yet, still; in spite of (that).`,
      `In whatever way or manner.`,
    ],
  },
  {
    word: `member`,
    wordInfo: [
      `One who officially belongs to a group.`,
      `(obsolete outside dialectal) To remember.`,
    ],
  },
  {
    word: `pay`,
    wordInfo: [
      `Money given in return for work; salary or wages.`,
      `To give money or other compensation to in exchange for goods or services.`,
      `To cover (the bottom of a vessel, a seam, a spar, etc.) with tar or pitch, or a waterproof composition of tallow, resin, etc.; to smear.`,
    ],
  },
  {
    word: `law`,
    wordInfo: [
      `The body of binding rules and regulations, customs and standards established in a community by its legislative and judicial authorities.`,
      `A tumulus of stones.`,
      `To work as a lawyer; to practice law.`,
    ],
  },
  {
    word: `meet`,
    wordInfo: [
      `A sports competition, especially for track and field (a track meet) or swimming (a swim meet).`,
      `Suitable; right; proper.`,
      `To make contact (with) while in proximity.`,
    ],
  },
  {
    word: `car`,
    wordInfo: [
      `A wheeled vehicle that moves independently, with at least three wheels, powered mechanically, steered by a driver and mostly for personal transportation.`,
      `A turn.`,
    ],
  },
  {
    word: `city`,
    wordInfo: [
      `A large settlement, bigger than a town; sometimes with a specific legal definition, depending on the place.`,
    ],
  },
  {
    word: `almost`,
    wordInfo: [
      `Something or someone that doesn't quite make it.`,
      `Very close to, not quite.`,
    ],
  },
  {
    word: `include`,
    wordInfo: [
      `A piece of source code or other content that is dynamically retrieved for inclusion in another item.`,
      `To bring into a group, class, set, or total as a (new) part or member.`,
    ],
  },
  {
    word: `continue`,
    wordInfo: [
      `An option allowing a gamer to resume play after game over, when all lives have been lost.`,
      `To proceed with (doing an activity); to prolong (an activity).`,
    ],
  },
  {
    word: `set`,
    wordInfo: [
      `To put (something) down, to rest.`,
      `A punch for setting nails in wood.`,
    ],
  },
  {
    word: `later`,
    wordInfo: [
      `Near the end of a period of time.`,
      `After a deadline has passed, past a designated time.`,
    ],
  },
  {
    word: `community`,
    wordInfo: [
      `A group sharing a common understanding, and often the same language, law, manners, and/or tradition.`,
    ],
  },
  { word: `much`, wordInfo: [`Large, great.`, `To a great extent.`] },
  {
    word: `name`,
    wordInfo: [
      `Any nounal word or phrase which indicates a particular person, place, class, or thing.`,
      `(ditransitive) To give a name to.`,
    ],
  },
  {
    word: `five`,
    wordInfo: [
      `The digit/figure 5.`,
      `A numerical value equal to 5; the number following four and preceding six.`,
    ],
  },
  {
    word: `once`,
    wordInfo: [
      `(frequency) One and only one time.`,
      `As soon as; when; after.`,
    ],
  },
  {
    word: `white`,
    wordInfo: [
      `The color/colour of snow or milk; the colour of light containing equal amounts of all visible wavelengths.`,
      `To make white; to whiten; to bleach.`,
    ],
  },
  {
    word: `least`,
    wordInfo: [
      `Something of the smallest possible extent; an indivisible unit.`,
      `Used for forming superlatives of adjectives, especially those that do not form the superlative by adding -est.`,
    ],
  },
  {
    word: `president`,
    wordInfo: [
      `An act in the past which may be used as an example to help decide the outcome of similar instances in the future.`,
      `The head of state of a republic.`,
    ],
  },
  {
    word: `learn`,
    wordInfo: [
      `The act of learning something`,
      `To teach.`,
      `To acquire, or attempt to acquire knowledge or an ability to do something.`,
    ],
  },
  {
    word: `real`,
    wordInfo: [
      `A commodity; see realty.`,
      `True, genuine, not merely nominal or apparent.`,
      `Former unit of currency of Spain and Spain's colonies.`,
    ],
  },
  {
    word: `change`,
    wordInfo: [
      `The process of becoming different.`,
      `To become something different.`,
    ],
  },
  {
    word: `team`,
    wordInfo: [
      `A set of draught animals, such as two horses in front of a carriage.`,
      `To form a group, as for sports or work.`,
    ],
  },
  {
    word: `minute`,
    wordInfo: [
      `A unit of time equal to sixty seconds (one-sixtieth of an hour).`,
      `Very small.`,
      `Of an event, to write in a memo or the minutes of a meeting.`,
    ],
  },
  {
    word: `best`,
    wordInfo: [
      `The supreme effort one can make, or has made.`,
      `To surpass in skill or achievement.`,
    ],
  },
  {
    word: `several`,
    wordInfo: [
      `An area of land in private ownership (as opposed to common land).`,
      `By itself; severally.`,
    ],
  },
  {
    word: `idea`,
    wordInfo: [
      `An abstract archetype of a given thing, compared to which real-life examples are seen as imperfect approximations; pure essence, as opposed to actual examples.`,
    ],
  },
  {
    word: `kid`,
    wordInfo: [
      `A young goat.`,
      `A fagot; a bundle of heath and furze.`,
      `To make a fool of (someone).`,
    ],
  },
  {
    word: `body`,
    wordInfo: [`Physical frame.`, `To give body or shape to something.`],
  },
  {
    word: `information`,
    wordInfo: [
      'That which resolves uncertainty; anything that answers the question of `what a given entity is`.',
    ],
  },
  {
    word: `nothing`,
    wordInfo: [
      `Something trifling, or of no consequence or importance.`,
      `Not at all; in no way.`,
    ],
  },
  {
    word: `ago`,
    wordInfo: [`Gone; gone by; gone away; passed; passed away.`, `Before`],
  },
  { word: `right`, wordInfo: [`Straight, not bent.`, `On the right side.`] },
  {
    word: `lead`,
    wordInfo: [
      `A heavy, pliable, inelastic metal element, having a bright, bluish color, but easily tarnished; both malleable and ductile, though with little tenacity. It is easily fusible, forms alloys with other metals, and is an ingredient of solder and type metal. Atomic number 82, symbol Pb (from Latin plumbum).`,
      `The act of leading or conducting; guidance; direction, course`,
      `To cover, fill, or affect with lead`,
      `(heading) To guide or conduct.`,
    ],
  },
  {
    word: `social`,
    wordInfo: [
      `A festive gathering to foster introductions.`,
      `Being extroverted or outgoing.`,
    ],
  },
  {
    word: `understand`,
    wordInfo: [
      `To grasp a concept fully and thoroughly, especially (of words, statements, art, etc.) to be aware of the meaning of and (of people) to be aware of the intent of.`,
    ],
  },
  {
    word: `whether`,
    wordInfo: [
      `Which of two.`,
      `Introducing a direct interrogative question (often with correlative or) which indicates doubt between alternatives.`,
    ],
  },
  {
    word: `back`,
    wordInfo: [
      `The rear of the body, especially the part between the neck and the end of the spine and opposite the chest and belly.`,
      `To go in the reverse direction.`,
      `A large shallow vat; a cistern, tub, or trough, used by brewers, distillers, dyers, picklers, gluemakers, and others, for mixing or cooling wort, holding water, hot glue, etc.`,
    ],
  },
  {
    word: `watch`,
    wordInfo: [
      `A portable or wearable timepiece.`,
      `To look at, see, or view for a period of time.`,
    ],
  },
  {
    word: `together`,
    wordInfo: [
      `Coherent; well organized.`,
      `At the same time, in the same place; in close association or proximity.`,
    ],
  },
  {
    word: `follow`,
    wordInfo: [
      `(sometimes attributive) In billiards and similar games, a stroke causing a ball to follow another ball after hitting it.`,
      `To go after; to pursue; to move behind in the same path or direction.`,
    ],
  },
  {
    word: `around`,
    wordInfo: [
      '(with the verb `to be`) Present in the vicinity.',
      `So as to form a circle or trace a circular path, or approximation thereof.`,
    ],
  },
  {
    word: `parent`,
    wordInfo: [
      `One of the two persons from whom one is immediately biologically descended; a mother or father.`,
      `To act as parent, to raise or rear.`,
    ],
  },
  { word: `only`, wordInfo: [`An only child.`, `Alone in a category.`] },
  {
    word: `stop`,
    wordInfo: [
      `A (usually marked) place where buses, trams or trains halt to let passengers get on and off, usually smaller than a station.`,
      `A small well-bucket; a milk-pail.`,
      `To cease moving.`,
    ],
  },
  {
    word: `face`,
    wordInfo: [
      `The front part of the head of a human or other animal, featuring the eyes, nose and mouth, and the surrounding area.`,
      `(of a person or animal) To position oneself or itself so as to have one's face closest to (something).`,
    ],
  },
  {
    word: `anything`,
    wordInfo: [
      `Someone or something of importance.`,
      `In any way, any extent or any degree.`,
      `Any object, act, state, event, or fact whatever; a thing of any kind; something or other.`,
    ],
  },
  {
    word: `create`,
    wordInfo: [
      `To bring into existence; (sometimes in particular:)`,
      `Created, resulting from creation.`,
    ],
  },
  {
    word: `public`,
    wordInfo: [
      `The people in general, regardless of membership of any particular group.`,
      `Able to be seen or known by everyone; open to general view, happening without concealment.`,
    ],
  },
  {
    word: `already`,
    wordInfo: [
      `Prior to some specified time, either past, present, or future; by this time; previously.`,
      `An intensifier used to emphasize impatience or express exasperation.`,
    ],
  },
  {
    word: `speak`,
    wordInfo: [
      `A low class bar, a speakeasy.`,
      `Language, jargon, or terminology used uniquely in a particular environment or group.`,
    ],
  },
  {
    word: `others`,
    wordInfo: [
      `An other, another (person, etc), more often rendered as another.`,
      'To regard, label or treat as an `other`, as not part of the same group; to view as different and alien.',
    ],
  },
  {
    word: `read`,
    wordInfo: [
      `A reading or an act of reading, especially an actor's part of a play.`,
      `To look at and interpret letters or other information that is written.`,
      `To look at and interpret letters or other information that is written.`,
    ],
  },
  {
    word: `level`,
    wordInfo: [
      `A tool for finding whether a surface is level, or for creating a horizontal or vertical line of reference.`,
      `To adjust so as to make as flat or perpendicular to the ground as possible.`,
    ],
  },
  {
    word: `allow`,
    wordInfo: [
      `To grant, give, admit, accord, afford, or yield; to let one have.`,
    ],
  },
  {
    word: `add`,
    wordInfo: [
      `An act or instance of adding.`,
      `To join or unite (e.g. one thing to another, or as several particulars) so as to increase the number, augment the quantity or enlarge the magnitude, or so as to form into one aggregate.`,
    ],
  },
  {
    word: `office`,
    wordInfo: [
      `A ceremonial duty or service, particularly:`,
      `To provide (someone) with an office.`,
    ],
  },
  {
    word: `spend`,
    wordInfo: [
      `Amount of money spent (during a period); expenditure.`,
      `To pay out (money).`,
    ],
  },
  {
    word: `door`,
    wordInfo: [
      `A portal of entry into a building, room, or vehicle, consisting of a rigid plane movable on a hinge. Doors are frequently made of wood or metal. May have a handle to help open and close, a latch to hold the door closed and a lock that ensures the door cannot be opened without the key.`,
      `To cause a collision by opening the door of a vehicle in front of an oncoming cyclist or pedestrian.`,
    ],
  },
  {
    word: `health`,
    wordInfo: [
      `The state of being free from physical or psychological disease, illness, or malfunction; wellness.`,
      `A warrior; hero; man.`,
    ],
  },
  {
    word: `person`,
    wordInfo: [
      `An individual; usually a human being.`,
      `To represent as a person; to personify; to impersonate.`,
    ],
  },
  {
    word: `art`,
    wordInfo: [
      `The conscious production or arrangement of sounds, colours, forms, movements, or other elements in a manner that affects the senses and emotions, usually specifically the production of the beautiful in a graphic or plastic medium.`,
    ],
  },
  {
    word: `sure`,
    wordInfo: [
      `Physically secure and certain, non-failing, reliable.`,
      `(modal adverb) Without doubt, certainly.`,
    ],
  },
  {
    word: `such`,
    wordInfo: [
      `Something being indicated that is similar to something else.`,
      `A person, a thing, people or things like the one or ones already mentioned.`,
    ],
  },
  {
    word: `war`,
    wordInfo: [
      `Organized, large-scale, armed conflict between countries or between national, ethnic, or other sizeable groups, usually involving the engagement of military forces.`,
      'To engage in conflict (may be followed by `with` to specify the foe).',
    ],
  },
  {
    word: `history`,
    wordInfo: [`The aggregate of past events.`, `To narrate or record.`],
  },
  {
    word: `party`,
    wordInfo: [
      `A person or group of people constituting a particular side in a contract or legal action.`,
      `(except in compounds) Divided; in part.`,
      `To celebrate at a party, to have fun, to enjoy oneself.`,
    ],
  },
  {
    word: `within`,
    wordInfo: [
      `In the context of which the present document or ruling is made.`,
      `In or into the interior; inside.`,
    ],
  },
  { word: `grow`, wordInfo: [`To become larger, to increase in magnitude.`] },
  {
    word: `result`,
    wordInfo: [
      `That which results; the conclusion or end to which any course or condition of things leads, or which is obtained by any process or operation; consequence or effect.`,
      `To proceed, spring up or rise, as a consequence, from facts, arguments, premises, combination of circumstances, consultation, thought or endeavor.`,
    ],
  },
  {
    word: `open`,
    wordInfo: [
      `Not closed`,
      `To make something accessible or allow for passage by moving from a shut position.`,
    ],
  },
  {
    word: `change`,
    wordInfo: [
      `The process of becoming different.`,
      `To become something different.`,
    ],
  },
  {
    word: `morning`,
    wordInfo: [
      `The part of the day from dawn to noon.`,
      `A greeting said in the morning; shortening of good morning`,
    ],
  },
  {
    word: `walk`,
    wordInfo: [
      `To move on the feet by alternately setting each foot (or pair or group of feet, in the case of animals with four or more feet) forward, with at least one foot on the ground at all times. Compare run.`,
      `A trip made by walking.`,
    ],
  },
  {
    word: `reason`,
    wordInfo: [
      `A cause:`,
      `To deduce or come to a conclusion by being rational`,
    ],
  },
  {
    word: `low`,
    wordInfo: [
      `Something that is low; a low point.`,
      `To depress; to lower.`,
      `To show mirth, satisfaction, or derision, by peculiar movement of the muscles of the face, particularly of the mouth, causing a lighting up of the face and eyes, and usually accompanied by the emission of explosive or chuckling sounds from the chest and throat; to indulge in laughter.`,
    ],
  },
  { word: `win`, wordInfo: [`To conquer, defeat.`, `An individual victory.`] },
  {
    word: `research`,
    wordInfo: [
      `Diligent inquiry or examination to seek or revise facts, principles, theories, applications, etc.; laborious or continued search after truth.`,
      `To search or examine with continued care; to seek diligently.`,
    ],
  },
  {
    word: `girl`,
    wordInfo: [
      `A female child, adolescent, or a young woman.`,
      `To feminize or girlify; to gender as a girl or as for girls.`,
    ],
  },
  {
    word: `guy`,
    wordInfo: [
      `An effigy of a man burned on a bonfire on the anniversary of the Gunpowder Plot (5th November).`,
      `A guide; a leader or conductor.`,
      `To exhibit an effigy of Guy Fawkes around the 5th November.`,
      `To equip with a support cable.`,
    ],
  },
  {
    word: `early`,
    wordInfo: [
      `A shift (scheduled work period) that takes place early in the day.`,
      `At a time in advance of the usual or expected event.`,
    ],
  },
  {
    word: `food`,
    wordInfo: [
      `Any solid substance that can be consumed by living organisms, especially by eating, in order to sustain life.`,
    ],
  },
  {
    word: `before`,
    wordInfo: [`At an earlier time.`, `Earlier than (in time).`],
  },
  { word: `moment`, wordInfo: [`A brief, unspecified amount of time.`] },
  {
    word: `himself`,
    wordInfo: [
      `(reflexive pronoun) Him; the male object of a verb or preposition that also appears as the subject`,
    ],
  },
  {
    word: `air`,
    wordInfo: [
      `The substance constituting earth's atmosphere, particularly:`,
      `To bring (something) into contact with the air, so as to freshen or dry it.`,
    ],
  },
  {
    word: `teacher`,
    wordInfo: [`A person who teaches, especially one employed in a school.`],
  },
  {
    word: `force`,
    wordInfo: [
      `Strength or energy of body or mind; active power; vigour; might; capacity of exercising an influence or producing an effect.`,
      `To violate (a woman); to rape.`,
      `A waterfall or cascade.`,
    ],
  },
  {
    word: `offer`,
    wordInfo: [
      `A proposal that has been made.`,
      `To propose or express one's willingness (to do something).`,
    ],
  },
  {
    word: `enough`,
    wordInfo: [
      `Sufficiently.`,
      `A sufficient or adequate number, amount, etc.`,
    ],
  },
  {
    word: `both`,
    wordInfo: [
      `Each of the two, or of the two kinds.`,
      `Including both of (used with and).`,
    ],
  },
  {
    word: `education`,
    wordInfo: [`The process of imparting knowledge, skill and judgment.`],
  },
  {
    word: `across`,
    wordInfo: [
      `(crosswords, often in combination) A word that runs horizontally in the completed puzzle grid or its associated clue.`,
      `From one side to the other.`,
    ],
  },
  {
    word: `although`,
    wordInfo: [
      `Though, even though, in spite of or despite the fact that: introducing a clause that expresses a concession.`,
    ],
  },
  {
    word: `remember`,
    wordInfo: [
      `To recall from one's memory; to have an image in one's memory.`,
      `To reconstitute or reassemble that which has been dismembered.`,
    ],
  },
  {
    word: `foot`,
    wordInfo: [
      `A biological structure found in many animals that is used for locomotion and that is frequently a separate organ at the terminal part of the leg.`,
      `To use the foot to kick (usually a ball).`,
    ],
  },
  {
    word: `second`,
    wordInfo: [
      `Something that is number two in a series.`,
      `To agree as a second person to (a proposal), usually to reach a necessary quorum of two. (See under #Etymology 3 for translations.)`,
      `One-sixtieth of a minute; the SI unit of time, defined as the duration of 9,192,631,770 periods of radiation corresponding to the transition between two hyperfine levels of caesium-133 in a ground state at a temperature of absolute zero and at rest.`,
    ],
  },
  {
    word: `boy`,
    wordInfo: [`A young male.`, `To use the word �boy� to refer to someone.`],
  },
  {
    word: `maybe`,
    wordInfo: [`Something that is possibly true.`, `Possible; uncertain.`],
  },
  {
    word: `toward`,
    wordInfo: [
      `Yielding, pliant; docile; ready or apt to learn; not froward.`,
      `In the direction of.`,
    ],
  },
  { word: `able`, wordInfo: [`Easy to use.`, `To make ready.`] },
  {
    word: `age`,
    wordInfo: [
      `The whole duration of a being, whether animal, plant, or other kind, being alive.`,
      `To cause to grow old; to impart the characteristics of age to.`,
    ],
  },
  {
    word: `off`,
    wordInfo: [
      `(usually in phrases such as 'from the off', 'at the off', etc.) Beginning; starting point.`,
      `To kill.`,
    ],
  },
  {
    word: `policy`,
    wordInfo: [
      `A principle of behaviour, conduct etc. thought to be desirable or necessary, especially as formally expressed by a government or other authoritative body.`,
      `A contract of insurance.`,
      `To regulate by laws; to reduce to order.`,
    ],
  },
  { word: `everything`, wordInfo: [`All the things under discussion.`] },
  {
    word: `love`,
    wordInfo: [
      `Strong affection.`,
      `To praise; commend.`,
      `(usually transitive, sometimes intransitive, stative) To have a strong affection for (someone or something).`,
    ],
  },
  {
    word: `process`,
    wordInfo: [
      `A series of events which produce a result (the product).`,
      `To walk in a procession`,
      `To perform a particular process on a thing.`,
    ],
  },
  {
    word: `music`,
    wordInfo: [
      `A series of sounds organized in time, employing melody, harmony, tempo etc. usually to convey a mood.`,
      `To seduce or entice with music.`,
    ],
  },
  {
    word: `including`,
    wordInfo: [
      `To bring into a group, class, set, or total as a (new) part or member.`,
      `Such as, among which; introducing one or more parts of the group or topic just mentioned.`,
    ],
  },
  { word: `consider`, wordInfo: [`To think about seriously.`] },
  {
    word: `appear`,
    wordInfo: [`To come or be in sight; to be in view; to become visible.`],
  },
  {
    word: `actually`,
    wordInfo: [`(modal) In act or in fact; really; in truth; positively.`],
  },
  {
    word: `buy`,
    wordInfo: [
      `Something which is bought; a purchase.`,
      `To obtain (something) in exchange for money or goods`,
    ],
  },
  { word: `probably`, wordInfo: [`In all likelihood.`] },
  {
    word: `human`,
    wordInfo: [
      `A human being, whether man, woman or child.`,
      `To behave as or become, or to cause to behave as or become, a human.`,
    ],
  },
  {
    word: `wait`,
    wordInfo: [
      `A delay.`,
      `To delay movement or action until the arrival or occurrence of; to await. (Now generally superseded by �wait for�.)`,
    ],
  },
  {
    word: `serve`,
    wordInfo: [
      `An act of putting the ball or shuttlecock in play in various games.`,
      `(personal) To provide a service (or, by extension, a product, especially food or drink).`,
    ],
  },
  {
    word: `market`,
    wordInfo: [
      `A gathering of people for the purchase and sale of merchandise at a set time, often periodic.`,
      `To make (products or services) available for sale and promote them.`,
    ],
  },
  {
    word: `die`,
    wordInfo: [
      `To stop living; to become dead; to undergo death.`,
      `A regular polyhedron, usually a cube, with numbers or symbols on each side and used in games of chance.`,
    ],
  },
  {
    word: `send`,
    wordInfo: [
      `The rising motion of water as a wave passes; a surge; the upward angular displacement of a vessel, opposed to pitch, the correlative downward movement.`,
      `An operation in which data is transmitted.`,
    ],
  },
  {
    word: `expect`,
    wordInfo: [`To predict or believe that something will happen`],
  },
  {
    word: `home`,
    wordInfo: [`A dwelling.`, `(of animals) To return to its owner.`],
  },
  {
    word: `sense`,
    wordInfo: [
      `Any of the manners by which living beings perceive the physical world: for humans sight, smell, hearing, touch, taste.`,
      `To use biological senses: to either see, hear, smell, taste, or feel.`,
    ],
  },
  {
    word: `build`,
    wordInfo: [
      `The physique of a human body; constitution or structure of a human body.`,
      `To form (something) by combining materials or parts.`,
    ],
  },
  {
    word: `stay`,
    wordInfo: [
      `Continuance or a period of time spent in a place; abode for an indefinite time; sojourn.`,
      `A prop; a support.`,
      `To prop; support; sustain; hold up; steady.`,
    ],
  },
  {
    word: `fall`,
    wordInfo: [
      `The act of moving to a lower position under the effect of gravity.`,
      `The chasing of a hunted whale.`,
      `(heading) To be moved downwards.`,
    ],
  },
  {
    word: `oh`,
    wordInfo: [
      `An utterance of oh; a spoken expression of surprise, acknowledgement, etc.`,
      `To utter the interjection oh; to express surprise, etc.`,
      `The letter O, o (more commonly spelled o)`,
    ],
  },
  {
    word: `nation`,
    wordInfo: [
      `A historically constituted, stable community of people, formed on the basis of a common language, territory, economic life, ethnicity and/or psychological make-up manifested in a common culture.`,
      `Damnation.`,
    ],
  },
  {
    word: `plan`,
    wordInfo: [
      `A drawing showing technical details of a building, machine, etc., with unwanted details omitted, and often using symbols rather than detailed drawing to represent doors, valves, etc.`,
      `To design (a building, machine, etc.).`,
    ],
  },
  {
    word: `cut`,
    wordInfo: [
      `The act of cutting.`,
      `(heading) To incise, to cut into the surface of something.`,
    ],
  },
  { word: `college`, wordInfo: [`A corporate group; a group of colleagues.`] },
  {
    word: `interest`,
    wordInfo: [
      `The price paid for obtaining, or price received for providing, money or goods in a credit transaction, calculated as a fraction of the amount or value of what was borrowed.`,
      `To engage the attention of; to awaken interest in; to excite emotion or passion in, in behalf of a person or thing.`,
    ],
  },
  {
    word: `death`,
    wordInfo: [
      `The cessation of life and all associated processes; the end of an organism's existence as an entity independent from its environment and its return to an inert, nonliving state.`,
    ],
  },
  {
    word: `course`,
    wordInfo: [
      `A sequence of events.`,
      `In due course; as a matter of course, as a natural result.`,
      `To run or flow (especially of liquids and more particularly blood).`,
    ],
  },
  {
    word: `someone`,
    wordInfo: [`A partially specified but unnamed person.`, `Some person.`],
  },
  {
    word: `experience`,
    wordInfo: [
      `The effect upon the judgment or feelings produced by any event, whether witnessed or participated in; personal and direct impressions as contrasted with description or fancies; personal acquaintance; actual enjoyment or suffering.`,
      `To observe certain events; undergo a certain feeling or process; or perform certain actions that may alter one or contribute to one's knowledge, opinions, or skills.`,
    ],
  },
  {
    word: `behind`,
    wordInfo: [`The rear, back-end`, `At the back part; in the rear.`],
  },
  {
    word: `reach`,
    wordInfo: [
      `The act of stretching or extending; extension.`,
      `To extend, stretch, or thrust out (for example a limb or object held in the hand).`,
    ],
  },
  {
    word: `local`,
    wordInfo: [
      `A person who lives near a given place.`,
      `From or in a nearby location.`,
    ],
  },
  {
    word: `kill`,
    wordInfo: [
      `The act of killing.`,
      `(north-east US) A creek; a body of water; a channel or arm of the sea.`,
      `To put to death; to extinguish the life of.`,
    ],
  },
  {
    word: `six`,
    wordInfo: [
      `The digit or figure 6.`,
      `A numerical value equal to 6; the number following five and preceding seven. This many dots: (������).`,
    ],
  },
  {
    word: `remain`,
    wordInfo: [
      `(chiefly in the plural) That which is left; relic; remainder.`,
      `To stay behind while others withdraw; to be left after others have been removed or destroyed; to be left after a number or quantity has been subtracted or cut off; to be left as not included or comprised.`,
    ],
  },
  {
    word: `effect`,
    wordInfo: [
      `The result or outcome of a cause.`,
      `To make or bring about; to implement.`,
    ],
  },
  { word: `use`, wordInfo: [`The act of using.`, `To utilize or employ.`] },
  {
    word: `yeah`,
    wordInfo: [
      `Expressing joy, celebration, glee, etc.`,
      `A solar year, the time it takes the Earth to complete one revolution of the Sun (between 365.24 and 365.26 days depending on the point of reference).`,
    ],
  },
  {
    word: `suggest`,
    wordInfo: [`To imply but stop short of saying explicitly.`],
  },
  {
    word: `class`,
    wordInfo: [
      `A group, collection, category or set sharing characteristics or attributes.`,
      `To assign to a class; to classify.`,
    ],
  },
  {
    word: `control`,
    wordInfo: [
      `Influence or authority over something.`,
      `To exercise influence over; to suggest or dictate the behavior of.`,
    ],
  },
  {
    word: `raise`,
    wordInfo: [
      `An increase in wages or salary; a rise (UK).`,
      `A cairn or pile of stones.`,
      `(physical) To cause to rise; to lift or elevate.`,
    ],
  },
  {
    word: `care`,
    wordInfo: [
      `Grief, sorrow.`,
      `To be concerned (about), to have an interest (in); to feel concern (about).`,
    ],
  },
  {
    word: `perhaps`,
    wordInfo: [
      `An uncertainty.`,
      `Modifies a verb, indicating a lack of certainty.`,
    ],
  },
  { word: `little`, wordInfo: [`A small amount.`, `Small in size.`] },
  {
    word: `late`,
    wordInfo: [
      `A shift (scheduled work period) that takes place late in the day or at night.`,
      `Near the end of a period of time.`,
    ],
  },
  {
    word: `hard`,
    wordInfo: [
      `A firm or paved beach or slope convenient for hauling vessels out of the water.`,
      `(of material or fluid) Having a severe property; presenting difficulty.`,
    ],
  },
  {
    word: `field`,
    wordInfo: [
      `A land area free of woodland, cities, and towns; open country.`,
      `To intercept or catch (a ball) and play it.`,
    ],
  },
  {
    word: `else`,
    wordInfo: [
      `(used only with indefinite or interrogative pronouns) Other; in addition to previously mentioned items.`,
      `(follows interrogative adverbs) Otherwise, if not.`,
    ],
  },
  {
    word: `pass`,
    wordInfo: [
      `To change place.`,
      `An opening, road, or track, available for passing; especially, one through or over some dangerous or otherwise impracticable barrier such as a mountain range; a passageway; a defile; a ford.`,
    ],
  },
  {
    word: `former`,
    wordInfo: [
      `Previous.`,
      `Someone who forms something; a maker; a creator or founder.`,
    ],
  },
  {
    word: `sell`,
    wordInfo: [
      `An act of selling.`,
      `A seat or stool.`,
      `(ditransitive) To transfer goods or provide services in exchange for money.`,
    ],
  },
  {
    word: `major`,
    wordInfo: [
      `A military rank between captain and lieutenant colonel.`,
      `The main area of study of a student working toward a degree at a college or university.`,
    ],
  },
  {
    word: `sometimes`,
    wordInfo: [
      `Former; sometime.`,
      `On certain occasions, or in certain circumstances, but not always.`,
    ],
  },
  {
    word: `require`,
    wordInfo: [`To ask (someone) for something; to request.`],
  },
  {
    word: `along`,
    wordInfo: [
      `In company; together.`,
      `By the length of; in a line with the length of; lengthwise next to.`,
    ],
  },
  {
    word: `development`,
    wordInfo: [`The process of developing; growth, directed change.`],
  },
  {
    word: `themselves`,
    wordInfo: [
      `The reflexive case of they, the third-person plural personal pronoun. The group of people, animals or objects previously mentioned, as the object of a verb or following a preposition (also used for emphasis).`,
    ],
  },
  {
    word: `report`,
    wordInfo: [
      `A piece of information describing, or an account of certain events given or presented to someone, with the most common adpositions being by (referring to creator of the report) and on (referring to the subject).`,
      `To relate details of (an event or incident); to recount, describe (something).`,
    ],
  },
  {
    word: `role`,
    wordInfo: [
      `A character or part played by a performer or actor.`,
      `An ancient unit of quantity, 72 sheets of parchment.`,
    ],
  },
  {
    word: `better`,
    wordInfo: [
      `An entity, usually animate, deemed superior to another; one who has a claim to precedence; a superior.`,
      `Greater in amount or quantity`,
      `To improve.`,
      `(with bare infinitive) Should; ought to; need to; must.`,
    ],
  },
  { word: `economic`, wordInfo: [`Pertaining to an economy.`] },
  {
    word: `effort`,
    wordInfo: [
      `The work involved in performing an activity; exertion.`,
      `To make an effort.`,
    ],
  },
  {
    word: `up`,
    wordInfo: [
      `The direction opposed to the pull of gravity.`,
      `To increase or raise.`,
    ],
  },
  {
    word: `decide`,
    wordInfo: [
      `To resolve (a contest, problem, dispute, etc.); to choose, determine, or settle`,
    ],
  },
  {
    word: `rate`,
    wordInfo: [
      `The worth of something; value.`,
      `To berate, scold.`,
      `To assign or be assigned a particular rank or level.`,
    ],
  },
  {
    word: `strong`,
    wordInfo: [
      `Capable of producing great physical force.`,
      `In a strong manner.`,
    ],
  },
  {
    word: `possible`,
    wordInfo: [
      `A possible one.`,
      `(usually not comparable) Able but not certain to happen; neither inevitable nor impossible.`,
    ],
  },
  {
    word: `heart`,
    wordInfo: [
      `A muscular organ that pumps blood through the body, traditionally thought to be the seat of emotion.`,
      `To be fond of. Often bracketed or abbreviated with a heart symbol.`,
    ],
  },
  {
    word: `drug`,
    wordInfo: [
      `A substance used to treat an illness, relieve a symptom, or modify a chemical process in the body for a specific purpose.`,
      `To pull along a surface or through a medium, sometimes with difficulty.`,
      `To administer intoxicating drugs to, generally without the recipient's knowledge or consent.`,
    ],
  },
  {
    word: `show`,
    wordInfo: [
      `A play, dance, or other entertainment.`,
      `To display, to have somebody see (something).`,
    ],
  },
  { word: `leader`, wordInfo: [`Any person that leads or directs`] },
  {
    word: `light`,
    wordInfo: [
      `Visible electromagnetic radiation. The human eye can typically detect radiation (light) in the wavelength range of about 400 to 750 nanometers. Nearby shorter and longer wavelength ranges, although not visible, are commonly called ultraviolet and infrared light.`,
      `To start (a fire).`,
    ],
  },
  {
    word: `voice`,
    wordInfo: [
      `Sound uttered by the mouth, especially by human beings in speech or song; sound thus uttered considered as possessing some special quality or character`,
      `To give utterance or expression to; to utter; to publish; to announce`,
    ],
  },
  {
    word: `wife`,
    wordInfo: [
      `A married woman, especially in relation to her spouse.`,
      `(said of men) to marry`,
    ],
  },
  {
    word: `whole`,
    wordInfo: [
      `Something complete, without any parts missing.`,
      `Entire, undivided.`,
    ],
  },
  {
    word: `police`,
    wordInfo: [
      `A civil force granted the legal authority for law enforcement and maintaining public order.`,
      `To enforce the law and keep order among (a group).`,
    ],
  },
  {
    word: `mind`,
    wordInfo: [
      `The ability for rational thought.`,
      `(originally and chiefly in negative or interrogative constructions) To dislike, to object to; to be bothered by.`,
    ],
  },
  { word: `finally`, wordInfo: [`At the end or conclusion; ultimately.`] },
  {
    word: `pull`,
    wordInfo: [
      `An act of pulling (applying force)`,
      `To apply a force to (an object) so that it comes toward the person or thing applying the force.`,
    ],
  },
  {
    word: `return`,
    wordInfo: [
      `The act of returning.`,
      `To come or go back (to a place or person).`,
    ],
  },
  {
    word: `free`,
    wordInfo: [`Free transfer`, `To make free; set at liberty; release.`],
  },
  {
    word: `military`,
    wordInfo: [
      `Armed forces.`,
      `Characteristic of members of the armed forces.`,
    ],
  },
  {
    word: `price`,
    wordInfo: [
      `The cost required to gain possession of something.`,
      `To determine the monetary value of (an item); to put a price on.`,
    ],
  },
  {
    word: `report`,
    wordInfo: [
      `A piece of information describing, or an account of certain events given or presented to someone, with the most common adpositions being by (referring to creator of the report) and on (referring to the subject).`,
      `To relate details of (an event or incident); to recount, describe (something).`,
    ],
  },
  {
    word: `less`,
    wordInfo: [
      `A smaller amount or quantity.`,
      `To make less; to lessen.`,
      `Unless`,
    ],
  },
  {
    word: `according`,
    wordInfo: [
      `To make to agree or correspond; to suit one thing to another; to adjust.`,
      `Agreeing; in agreement or harmony; harmonious.`,
    ],
  },
  {
    word: `decision`,
    wordInfo: [
      `The act of deciding.`,
      `To defeat an opponent by a decision of the judges, rather than by a knockout`,
    ],
  },
  {
    word: `explain`,
    wordInfo: [
      `To make plain, manifest, or intelligible; to clear of obscurity; to illustrate the meaning of.`,
    ],
  },
  {
    word: `son`,
    wordInfo: [
      `One's male offspring.`,
      `To produce (i.e. bear, father, beget) a son.`,
    ],
  },
  {
    word: `hope`,
    wordInfo: [
      `To want something to happen, with a sense of expectation that it might.`,
      `The feeling of trust, confidence, belief or expectation that something wished for can or will happen.`,
    ],
  },
  {
    word: `even`,
    wordInfo: [
      `(diminutive) An even number.`,
      `To make flat and level.`,
      `Evening.`,
    ],
  },
  {
    word: `develop`,
    wordInfo: [`To change with a specific direction, progress.`],
  },
  { word: `view`, wordInfo: [`(physical) Visual perception.`, `To look at.`] },
  {
    word: `relationship`,
    wordInfo: [`Connection or association; the condition of being related.`],
  },
  {
    word: `carry`,
    wordInfo: [
      `A manner of transporting or lifting something; the grip or position in which something is carried.`,
      `To lift (something) and take it to another place; to transport (something) by lifting.`,
    ],
  },
  {
    word: `town`,
    wordInfo: [
      `A settlement; an area with residential districts, shops and amenities, and its own local government; especially one larger than a village and smaller than a city.`,
    ],
  },
  {
    word: `road`,
    wordInfo: [
      `A way used for travelling between places, originally one wide enough to allow foot passengers and horses to travel, now (US) usually one surfaced with asphalt or concrete and designed to accommodate many vehicles travelling in both directions. In the UK both senses are heard: a country road is the same as a country lane.`,
      `At the venue of the opposing team or competitor; on the road.`,
    ],
  },
  {
    word: `drive`,
    wordInfo: [
      `Motivation to do or achieve something; ability coupled with ambition.`,
      `To provide an impetus for motion or other physical change, to move an object by means of the provision of force thereto.`,
    ],
  },
  {
    word: `arm`,
    wordInfo: [
      `The portion of the upper human appendage, from the shoulder to the wrist and sometimes including the hand.`,
      `Poor; lacking in riches or wealth.`,
      `To take by the arm; to take up in one's arms.`,
    ],
  },
  {
    word: `true`,
    wordInfo: [`The state of being in alignment.`, `To straighten.`],
  },
  {
    word: `federal`,
    wordInfo: [
      `A law-enforcement official of the FBI; a federal agent.`,
      `Pertaining to a league or treaty; derived from an agreement or covenant between parties, especially between nations.`,
    ],
  },
  {
    word: `break`,
    wordInfo: [
      `An instance of breaking something into two or more pieces.`,
      `A section of extended repetition of the percussion break to a song, created by a hip-hop DJ as rhythmic dance music.`,
      `To separate into two or more pieces, to fracture or crack, by a process that cannot easily be reversed for reassembly.`,
    ],
  },
  {
    word: `better`,
    wordInfo: [
      `An entity, usually animate, deemed superior to another; one who has a claim to precedence; a superior.`,
      `Greater in amount or quantity`,
      `To improve.`,
      `(with bare infinitive) Should; ought to; need to; must.`,
    ],
  },
  {
    word: `difference`,
    wordInfo: [
      `The quality of being different.`,
      `To distinguish or differentiate.`,
    ],
  },
  {
    word: `thank`,
    wordInfo: [
      `An expression of appreciation; a thought.`,
      `To express gratitude or appreciation toward.`,
    ],
  },
  {
    word: `receive`,
    wordInfo: [
      `An operation in which data is received.`,
      `To take, as something that is offered, given, committed, sent, paid, etc.; to accept; to be given something.`,
    ],
  },
  {
    word: `value`,
    wordInfo: [
      `The quality (positive or negative) that renders something desirable or valuable.`,
      `To estimate the value of; judge the worth of something.`,
    ],
  },
  {
    word: `international`,
    wordInfo: [
      `Someone who has represented their country in a particular sport.`,
      `Of or having to do with more than one nation.`,
    ],
  },
  {
    word: `building`,
    wordInfo: [
      `The act or process by which something is built; construction.`,
      `To form (something) by combining materials or parts.`,
    ],
  },
  {
    word: `action`,
    wordInfo: [
      `Something done so as to accomplish a purpose.`,
      `To act on a request etc, in order to put it into effect.`,
    ],
  },
  {
    word: `full`,
    wordInfo: [
      `Containing the maximum possible amount that can fit in the space available.`,
      `Utmost measure or extent; highest state or degree; the state, position, or moment of fullness; fill.`,
      `Fully; quite; very; thoroughly; completely; exactly; entirely.`,
      `(of the moon) To become full or wholly illuminated.`,
    ],
  },
  {
    word: `model`,
    wordInfo: [
      `A person who serves as a subject for artwork or fashion, usually in the medium of photography but also for painting or drawing.`,
      `To display for others to see, especially in regard to wearing clothing while performing the role of a fashion model`,
    ],
  },
  {
    word: `join`,
    wordInfo: [
      `An intersection of piping or wiring; an interconnect.`,
      `To connect or combine into one; to put together.`,
    ],
  },
  {
    word: `season`,
    wordInfo: [
      `Each of the four divisions of a year: spring, summer, autumn (fall) and winter`,
      `To flavour food with spices, herbs or salt.`,
      `To make fit for any use by time or habit; to habituate; to accustom; to inure.`,
    ],
  },
  {
    word: `society`,
    wordInfo: [
      `A long-standing group of people sharing cultural aspects such as language, dress, norms of behavior and artistic forms.`,
    ],
  },
  {
    word: `because`,
    wordInfo: [`For the reason (that).`, `On account of, because of.`],
  },
  {
    word: `tax`,
    wordInfo: [
      `Money paid to the government other than for transaction-specific goods and services.`,
      `To impose and collect a tax from (a person or company).`,
    ],
  },
  {
    word: `director`,
    wordInfo: [
      `One who directs; the person in charge of managing a department or directorate (e.g., director of engineering), project, or production (as in a show or film, e.g., film director).`,
    ],
  },
  {
    word: `early`,
    wordInfo: [
      `A shift (scheduled work period) that takes place early in the day.`,
      `At a time in advance of the usual or expected event.`,
    ],
  },
  {
    word: `position`,
    wordInfo: [`A place or location.`, `To put into place.`],
  },
  { word: `player`, wordInfo: [`One that plays`] },
  {
    word: `agree`,
    wordInfo: [
      `To harmonize in opinion, statement, or action; to be in unison or concord; to be or become united or consistent; to concur.`,
    ],
  },
  {
    word: `especially`,
    wordInfo: [`(manner) In a special manner; specially.`],
  },
  {
    word: `record`,
    wordInfo: [
      `A disk, usually made of a polymer, used to record sound for playback on a phonograph.`,
      `To make a record of information.`,
      `An item of information put into a temporary or permanent physical medium.`,
    ],
  },
  {
    word: `pick`,
    wordInfo: [
      `A tool used for digging; a pickaxe.`,
      `To grasp and pull with the fingers or fingernails.`,
    ],
  },
  {
    word: `wear`,
    wordInfo: [
      `(in combination) clothing`,
      `To guard; watch; keep watch, especially from entry or invasion.`,
      `To carry or have equipped on or about one's body, as an item of clothing, equipment, decoration, etc.`,
    ],
  },
  {
    word: `paper`,
    wordInfo: [
      `A sheet material used for writing on or printing on (or as a non-waterproof container), usually made by draining cellulose fibres from a suspension in water.`,
      `To apply paper to.`,
    ],
  },
  {
    word: `special`,
    wordInfo: [
      `A reduction in consumer cost (usually for a limited time) for items or services rendered.`,
      `(nursing) To supervise a patient one-on-one.`,
    ],
  },
  { word: `space`, wordInfo: [`(heading) Of time.`, `To roam, walk, wander.`] },
  {
    word: `ground`,
    wordInfo: [
      `The surface of the Earth, as opposed to the sky or water or underground.`,
      `To reduce to smaller pieces by crushing with lateral motion.`,
      `To connect (an electrical conductor or device) to a ground.`,
      `Crushed, or reduced to small particles.`,
    ],
  },
  {
    word: `form`,
    wordInfo: [
      `(heading, physical) To do with shape.`,
      `To assume (a certain shape or visible structure).`,
    ],
  },
  {
    word: `support`,
    wordInfo: [
      `(sometimes attributive) Something which supports.`,
      `To keep from falling.`,
    ],
  },
  {
    word: `event`,
    wordInfo: [
      `An occurrence; something that happens.`,
      `To be emitted or breathed out; to evaporate.`,
      `To occur, take place.`,
    ],
  },
  {
    word: `official`,
    wordInfo: [
      `An office holder invested with powers and authorities.`,
      `Of or pertaining to an office or public trust.`,
    ],
  },
  {
    word: `whose`,
    wordInfo: [`(interrogative) That or those of whom or belonging to whom.`],
  },
  { word: `matter`, wordInfo: [`Substance, material.`, `To be important.`] },
  { word: `everyone`, wordInfo: [`Every person.`] },
  {
    word: `center`,
    wordInfo: [
      `The point in the interior of a circle that is equidistant from all points on the circumference.`,
      `To cause (an object) to occupy the center of an area.`,
    ],
  },
  {
    word: `couple`,
    wordInfo: [
      `Two partners in a romantic or sexual relationship.`,
      `To join (two things) together, or (one thing) to (another).`,
    ],
  },
  {
    word: `site`,
    wordInfo: [
      `Sorrow, grief.`,
      `The place where anything is fixed; situation; local position`,
    ],
  },
  {
    word: `end`,
    wordInfo: [
      `The terminal point of something in space or time.`,
      `To come to an end`,
    ],
  },
  {
    word: `project`,
    wordInfo: [
      `A planned endeavor, usually with a specific goal and accomplished in several steps or stages.`,
      `To extend beyond a surface.`,
    ],
  },
  {
    word: `hit`,
    wordInfo: [
      `A blow; a punch; a striking against; the collision of one body against another; the stroke that touches anything.`,
      `(heading, physical) To strike.`,
      `It.`,
    ],
  },
  {
    word: `base`,
    wordInfo: [
      `Something from which other things extend; a foundation.`,
      `To give as its foundation or starting point; to lay the foundation of.`,
      `Low in height; short.`,
      `Of sound, a voice or an instrument, low in pitch or frequency.`,
    ],
  },
  {
    word: `activity`,
    wordInfo: [`The state or quality of being active; activeness.`],
  },
  {
    word: `star`,
    wordInfo: [
      `Any small luminous dot appearing in the cloudless portion of the night sky, especially with a fixed location relative to other such dots.`,
      `To appear as a featured performer or headliner, especially in an entertainment program.`,
    ],
  },
  {
    word: `table`,
    wordInfo: [
      `Furniture with a top surface to accommodate a variety of uses.`,
      `To tabulate; to put into a table or grid.`,
    ],
  },
  {
    word: `need`,
    wordInfo: [
      `A requirement for something; something needed.`,
      `To have an absolute requirement for.`,
    ],
  },
  {
    word: `court`,
    wordInfo: [
      `An enclosed space; a courtyard; an uncovered area shut in by the walls of a building, or by different buildings; also, a space opening from a street and nearly surrounded by houses; a blind alley.`,
      `To seek to achieve or win.`,
    ],
  },
  {
    word: `produce`,
    wordInfo: [
      `To yield, make or manufacture; to generate.`,
      `That which is produced.`,
    ],
  },
  {
    word: `eat`,
    wordInfo: [
      `Something to be eaten; a meal; a food item.`,
      `To ingest; to be ingested.`,
    ],
  },
  {
    word: `teach`,
    wordInfo: [
      `To show (someone) the way; to guide, conduct; to point, indicate.`,
      `(usually as a term of address) teacher`,
    ],
  },
  { word: `oil`, wordInfo: [`Liquid fat.`, `To lubricate with oil.`] },
  {
    word: `half`,
    wordInfo: [
      `One of two usually roughly equal parts into which anything may be divided, or considered as divided.`,
      `To halve.`,
    ],
  },
  {
    word: `situation`,
    wordInfo: [
      `The combination of circumstances at a given moment; a state of affairs.`,
    ],
  },
  {
    word: `easy`,
    wordInfo: [`Something that is easy`, `Comfortable; at ease.`],
  },
  {
    word: `cost`,
    wordInfo: [
      `To incur a charge of; to require payment of a (specified) price.`,
      `Amount of money, time, etc. that is required or used.`,
    ],
  },
  {
    word: `industry`,
    wordInfo: [`The tendency to work persistently. Diligence.`],
  },
  {
    word: `figure`,
    wordInfo: [
      `A drawing or diagram conveying information.`,
      `To calculate, to solve a mathematical problem.`,
    ],
  },
  {
    word: `face`,
    wordInfo: [
      `The front part of the head of a human or other animal, featuring the eyes, nose and mouth, and the surrounding area.`,
      `(of a person or animal) To position oneself or itself so as to have one's face closest to (something).`,
    ],
  },
  {
    word: `street`,
    wordInfo: [
      `A paved part of road, usually in a village or a town.`,
      `To build or equip with streets.`,
    ],
  },
  {
    word: `image`,
    wordInfo: [
      `An optical or other representation of a real object; a graphic; a picture.`,
      `To represent by an image or symbol; to portray.`,
    ],
  },
  {
    word: `itself`,
    wordInfo: [
      `(reflexive pronoun) it; A thing as the object of a verb or preposition that also appears as the subject`,
    ],
  },
  {
    word: `phone`,
    wordInfo: [
      `A device for transmitting conversations and other sounds in real time across distances, now often a small portable unit also capable of running software etc.`,
      `A speech segment that possesses distinct physical or perceptual properties, considered as a physical event without regard to its place in the phonology of a language.`,
      `To call (someone) using a telephone.`,
    ],
  },
  {
    word: `either`,
    wordInfo: [
      `(after a negative) As well.`,
      `One or other of two people or things.`,
    ],
  },
  {
    word: `data`,
    wordInfo: [
      `(plural: data) A measurement of something on a scale understood by both the recorder (a person or device) and the reader (another person or device). The scale is arbitrarily defined, such as from 1 to 10 by ones, 1 to 100 by 0.1, or simply true or false, on or off, yes, no, or maybe, etc.`,
    ],
  },
  {
    word: `cover`,
    wordInfo: [
      `A lid.`,
      `To place something over or upon, as to conceal or protect.`,
    ],
  },
  {
    word: `quite`,
    wordInfo: [
      `(heading) To the greatest extent or degree; completely, entirely.`,
      `A series of passes made with the cape to distract the bull.`,
      'Indicates agreement; `exactly so`.',
    ],
  },
  {
    word: `picture`,
    wordInfo: [
      `A representation of anything (as a person, a landscape, a building) upon canvas, paper, or other surface, by drawing, painting, printing, photography, etc.`,
      `To represent in or with a picture.`,
    ],
  },
  {
    word: `clear`,
    wordInfo: [
      `Full extent; distance between extreme limits; especially; the distance between the nearest surfaces of two bodies, or the space between walls.`,
      `To remove obstructions, impediments or other unwanted items from.`,
    ],
  },
  {
    word: `practice`,
    wordInfo: [
      `Repetition of an activity to improve a skill.`,
      `To repeat (an activity) as a way of improving one's skill in that activity.`,
    ],
  },
  {
    word: `piece`,
    wordInfo: [
      `A part of a larger whole, usually in such a form that it is able to be separated from other parts.`,
      `(usually with together) To assemble (something real or figurative).`,
    ],
  },
  {
    word: `land`,
    wordInfo: [
      `The part of Earth which is not covered by oceans or other bodies of water.`,
      `To descend to a surface, especially from the air.`,
      `Lant; urine`,
    ],
  },
  { word: `recent`, wordInfo: [`Having happened a short while ago.`] },
  { word: `describe`, wordInfo: [`To represent in words.`] },
  {
    word: `product`,
    wordInfo: [`A commodity offered for sale.`, `To produce.`],
  },
  {
    word: `doctor`,
    wordInfo: [
      `A physician; a member of the medical profession; one who is trained and licensed to heal the sick or injured. The final examination and qualification may award a doctor degree in which case the post-nominal letters are D.O., DPM, M.D., DMD, DDS, in the US or MBBS in the UK.`,
      `To act as a medical doctor to.`,
    ],
  },
  {
    word: `wall`,
    wordInfo: [
      `A rampart of earth, stones etc. built up for defensive purposes.`,
      `To boil.`,
      `To enclose with, or as if with, a wall or walls.`,
    ],
  },
  {
    word: `patient`,
    wordInfo: [
      `A person or animal who receives treatment from a doctor or other medically educated person.`,
      `(of a person) Willing to wait if necessary; not losing one's temper while waiting.`,
    ],
  },
  {
    word: `worker`,
    wordInfo: [
      `A person who performs labor for a living, especially manual labor.`,
    ],
  },
  {
    word: `news`,
    wordInfo: [`New information of interest.`, `To report; to make known.`],
  },
  {
    word: `test`,
    wordInfo: [
      `A challenge, trial.`,
      `A witness.`,
      `To challenge.`,
      `To attest (a document) legally, and date it.`,
    ],
  },
  {
    word: `movie`,
    wordInfo: [
      `A recorded sequence of images displayed on a screen at a rate sufficiently fast to create the appearance of motion.`,
    ],
  },
  {
    word: `certain`,
    wordInfo: [
      '(with `the`) Something certain.',
      `Sure, positive, not doubting.`,
    ],
  },
  {
    word: `north`,
    wordInfo: [
      `One of the four major compass points, specifically 0�, directed toward the North Pole, and conventionally upwards on a map, abbreviated as N.`,
      `To turn or move toward the north.`,
    ],
  },
  {
    word: `love`,
    wordInfo: [
      `Strong affection.`,
      `To praise; commend.`,
      `(usually transitive, sometimes intransitive, stative) To have a strong affection for (someone or something).`,
    ],
  },
  {
    word: `personal`,
    wordInfo: [
      `An advertisement by which individuals attempt to meet others with similar interests.`,
      `Pertaining to human beings as distinct from things.`,
    ],
  },
  {
    word: `open`,
    wordInfo: [
      `Not closed`,
      `To make something accessible or allow for passage by moving from a shut position.`,
    ],
  },
  {
    word: `support`,
    wordInfo: [
      `(sometimes attributive) Something which supports.`,
      `To keep from falling.`,
    ],
  },
  {
    word: `simply`,
    wordInfo: [
      `(manner) In a simple way or state; considered in or by itself; without addition; alone.`,
    ],
  },
  {
    word: `third`,
    wordInfo: [
      `The person or thing in the third position.`,
      `To agree with a proposition or statement after it has already been seconded.`,
    ],
  },
  {
    word: `technology`,
    wordInfo: [`The organization of knowledge for practical purposes.`],
  },
  {
    word: `catch`,
    wordInfo: [
      `The act of seizing or capturing.`,
      `(heading) To capture, overtake.`,
    ],
  },
  {
    word: `step`,
    wordInfo: [
      `An advance or movement made from one foot to the other; a pace.`,
      `To move the foot in walking; to advance or recede by raising and moving one of the feet to another resting place, or by moving both feet in succession.`,
    ],
  },
  {
    word: `baby`,
    wordInfo: [
      `A very young human, particularly from birth to a couple of years old or until walking is fully mastered.`,
      `To coddle; to pamper somebody like an infant.`,
    ],
  },
  {
    word: `computer`,
    wordInfo: [`A person employed to perform computations; one who computes.`],
  },
  {
    word: `type`,
    wordInfo: [
      `A grouping based on shared characteristics; a class.`,
      `To put text on paper using a typewriter.`,
    ],
  },
  {
    word: `attention`,
    wordInfo: [
      `Mental focus.`,
      `Used as a command to bring soldiers to the attention position.`,
    ],
  },
  {
    word: `draw`,
    wordInfo: [
      `The result of a contest that neither side has won; a tie.`,
      `To move or develop something.`,
    ],
  },
  {
    word: `film`,
    wordInfo: [
      `A thin layer of some substance; a pellicle; a membranous covering, causing opacity.`,
      `To record (activity, or a motion picture) on photographic film.`,
    ],
  },
  {
    word: `Republican`,
    wordInfo: [
      `Someone who favors a republic as a form of government.`,
      `Advocating or supporting a republic as a form of government, advocating or supporting republicanism.`,
    ],
  },
  {
    word: `tree`,
    wordInfo: [
      `Fast growing function based on Kruskal's tree theorem.`,
      `A perennial woody plant, not exactly defined, but differentiated from a shrub by its larger size (typically over a few meters in height) or growth habit, usually having a single (or few) main axis or trunk unbranched for some distance above the ground and a head of branches and foliage.`,
    ],
  },
  {
    word: `source`,
    wordInfo: [
      `The person, place or thing from which something (information, goods, etc.) comes or is acquired.`,
      `To obtain or procure: used especially of a business resource.`,
    ],
  },
  {
    word: `red`,
    wordInfo: [
      `Any of a range of colours having the longest wavelengths, 670 nm, of the visible spectrum; a primary additive colour for transmitted light: the colour obtained by subtracting green and blue from white light using magenta and yellow filters; the colour of blood, ripe strawberries, etc.`,
      `To govern, protect.`,
      `Having red as its color.`,
    ],
  },
  { word: `nearly`, wordInfo: [`With great scrutiny; carefully.`] },
  { word: `organization`, wordInfo: [`The quality of being organized.`] },
  {
    word: `choose`,
    wordInfo: [
      `To pick; to make the choice of; to select.`,
      `The act of choosing; selection.`,
      `The binomial coefficient of the previous and following number.`,
    ],
  },
  {
    word: `cause`,
    wordInfo: [
      `(often with of, typically of adverse results) The source of, or reason for, an event or action; that which produces or effects a result.`,
      `To set off an event or action.`,
    ],
  },
  {
    word: `hair`,
    wordInfo: [
      `A pigmented filament of keratin which grows from a follicle on the skin of humans and other mammals.`,
      `To remove the hair from.`,
    ],
  },
  {
    word: `point`,
    wordInfo: [
      `A discrete division of something.`,
      `To extend the index finger in the direction of something in order to show where it is or to draw attention to it.`,
    ],
  },
  {
    word: `century`,
    wordInfo: [
      `A period of 100 consecutive years; often specifically a numbered period with conventional start and end dates, e.g., the twentieth century, which stretches from (strictly) 1901 through 2000, or (informally) 1900 through 1999. The first century AD was from 1 to 100.`,
    ],
  },
  {
    word: `evidence`,
    wordInfo: [
      `Facts or observations presented in support of an assertion.`,
      `To provide evidence for, or suggest the truth of.`,
    ],
  },
  {
    word: `window`,
    wordInfo: [
      `The inedible parts of a grain-producing plant.`,
      `An opening, usually covered by one or more panes of clear glass, to allow light and air from outside to enter a building or vehicle.`,
    ],
  },
  {
    word: `difficult`,
    wordInfo: [
      `To make difficult; to impede; to perplex.`,
      `Hard, not easy, requiring much effort.`,
    ],
  },
  {
    word: `listen`,
    wordInfo: [
      `An instance of listening.`,
      `To pay attention to a sound or speech.`,
    ],
  },
  {
    word: `soon`,
    wordInfo: [
      `Short in length of time from the present.`,
      `Immediately, instantly.`,
    ],
  },
  {
    word: `culture`,
    wordInfo: [
      `The arts, customs, lifestyles, background, and habits that characterize a particular society or nation.`,
      `To maintain in an environment suitable for growth (especially of bacteria) (compare cultivate)`,
    ],
  },
  {
    word: `billion`,
    wordInfo: [
      `(modern British & Australian, short scale) a thousand million (logic: 1,000 � 1,000^2): 1 followed by nine zeros, 109; a milliard`,
    ],
  },
  {
    word: `chance`,
    wordInfo: [
      `An opportunity or possibility.`,
      `Happening by chance, casual.`,
      `To happen by chance, to occur.`,
    ],
  },
  {
    word: `brother`,
    wordInfo: [
      `Son of the same parents as another person.`,
      `To treat as a brother.`,
    ],
  },
  {
    word: `energy`,
    wordInfo: [`The impetus behind all motion and all activity.`],
  },
  {
    word: `period`,
    wordInfo: [`A length of time.`, `To come to a period; to conclude.`],
  },
  {
    word: `course`,
    wordInfo: [
      `A sequence of events.`,
      `In due course; as a matter of course, as a natural result.`,
      `To run or flow (especially of liquids and more particularly blood).`,
    ],
  },
  {
    word: `summer`,
    wordInfo: [
      `One of four seasons, traditionally the second, marked by the longest and typically hottest days of the year due to the inclination of the Earth and thermal lag. Typically regarded as being from June 21 to September 22 or 23 in parts of the USA, the months of June, July and August in the United Kingdom and the months of December, January and February in the Southern Hemisphere.`,
      `A pack-horse.`,
      `To spend the summer, as in a particular place on holiday.`,
    ],
  },
  {
    word: `less`,
    wordInfo: [
      `A smaller amount or quantity.`,
      `To make less; to lessen.`,
      `Unless`,
    ],
  },
  {
    word: `realize`,
    wordInfo: [
      `To make real; to convert from the imaginary or fictitious into reality; to bring into real existence`,
    ],
  },
  {
    word: `hundred`,
    wordInfo: [
      `A hundred-dollar bill, or any other note denominated 100 (e.g. a hundred euros).`,
      `A numerical value equal to 100 (102), occurring after ninety-nine.`,
    ],
  },
  {
    word: `available`,
    wordInfo: [
      `Such as one may avail oneself of; capable of being used for the accomplishment of a purpose.`,
    ],
  },
  {
    word: `plant`,
    wordInfo: [
      `An organism that is not an animal, especially an organism capable of photosynthesis. Typically a small or herbaceous organism of this kind, rather than a tree.`,
      `To place (a seed or plant) in soil or other substrate in order that it may live and grow.`,
    ],
  },
  {
    word: `likely`,
    wordInfo: [
      `Something or somebody considered likely.`,
      `Similarly.`,
      `Probable; having a greater-than-even chance of occurring`,
    ],
  },
  {
    word: `opportunity`,
    wordInfo: [`A chance for advancement, progress or profit.`],
  },
  {
    word: `term`,
    wordInfo: [
      `That which limits the extent of anything; limit, extremity, bound, boundary.`,
      `To phrase a certain way; to name or call.`,
      `A computer program that emulates a physical terminal.`,
    ],
  },
  {
    word: `short`,
    wordInfo: [`A short circuit.`, `To cause a short circuit in (something).`],
  },
  {
    word: `letter`,
    wordInfo: [
      `A symbol in an alphabet.`,
      `To print, inscribe, or paint letters on something.`,
      `One who lets, or lets out.`,
    ],
  },
  {
    word: `condition`,
    wordInfo: [
      `A logical clause or phrase that a conditional statement uses. The phrase can either be true or false.`,
      `To subject to the process of acclimation.`,
    ],
  },
  {
    word: `choice`,
    wordInfo: [
      `An option; a decision; an opportunity to choose or select something.`,
      `Especially good or preferred.`,
    ],
  },
  {
    word: `place`,
    wordInfo: [
      `(physical) An area; somewhere within an area.`,
      `To put (an object or person) in a specific location.`,
    ],
  },
  {
    word: `single`,
    wordInfo: [
      `A 45 RPM vinyl record with one song on side A and one on side B.`,
      `To identify or select one member of a group from the others; generally used with out, either to single out or to single (something) out.`,
    ],
  },
  {
    word: `rule`,
    wordInfo: [
      `A regulation, law, guideline.`,
      `To regulate, be in charge of, make decisions for, reign over.`,
    ],
  },
  { word: `daughter`, wordInfo: [`One�s female offspring.`] },
  {
    word: `administration`,
    wordInfo: [
      `The act of administering; government of public affairs; the service rendered, or duties assumed, in conducting affairs; the conducting of any office or employment; direction.`,
    ],
  },
  {
    word: `south`,
    wordInfo: [
      `One of the four major compass points, specifically 180�, directed toward the South Pole, and conventionally downwards on a map, abbreviated as S.`,
      `To turn or move toward the south; to veer toward the south.`,
    ],
  },
  {
    word: `husband`,
    wordInfo: [
      `The master of a house; the head of a family; a householder.`,
      `To manage or administer carefully and frugally; use to the best advantage; economise.`,
    ],
  },
  {
    word: `Congress`,
    wordInfo: [
      `A coming together of two or more people; a meeting.`,
      `To assemble together.`,
    ],
  },
  {
    word: `floor`,
    wordInfo: [
      `The interior bottom or surface of a house or building; the supporting surface of a room.`,
      `To cover or furnish with a floor.`,
    ],
  },
  {
    word: `campaign`,
    wordInfo: [
      `A series of operations undertaken to achieve a set goal.`,
      `To take part in a campaign.`,
    ],
  },
  {
    word: `material`,
    wordInfo: [
      `Matter which may be shaped or manipulated, particularly in making something.`,
      `To form from matter; to materialize.`,
    ],
  },
  {
    word: `population`,
    wordInfo: [
      `The people living within a political or geographical boundary.`,
    ],
  },
  {
    word: `well`,
    wordInfo: [
      `In good health.`,
      `(manner) Accurately, competently, satisfactorily.`,
      `A hole sunk into the ground as a source of water, oil, natural gas or other fluids.`,
    ],
  },
  {
    word: `call`,
    wordInfo: [`A telephone conversation.`, `(heading) To use one's voice.`],
  },
  {
    word: `economy`,
    wordInfo: [
      `Effective management of a community or system, or especially its resources.`,
      `Cheap to run; using minimal resources; representing good value for money.`,
    ],
  },
  {
    word: `medical`,
    wordInfo: [
      `A medical examination.`,
      `Of or pertaining to the practice of medicine.`,
    ],
  },
  {
    word: `hospital`,
    wordInfo: [
      `A large medical facility, usually in a building with multiple floors, where seriously ill or injured patients are given extensive medical and/or surgical treatment.`,
      `Hospitable.`,
    ],
  },
  {
    word: `church`,
    wordInfo: [
      `A Christian house of worship; a building where Christian religious services take place.`,
      `To conduct a religious service for (a woman after childbirth, or a newly married couple).`,
    ],
  },
  {
    word: `close`,
    wordInfo: [
      `An end or conclusion.`,
      `(chiefly Yorkshire) An enclosed field.`,
      `(physical) To remove a gap.`,
      `Closed, shut.`,
    ],
  },
  {
    word: `thousand`,
    wordInfo: [`A numerical value equal to 1,000 = 10 � 100 = 103`],
  },
  {
    word: `risk`,
    wordInfo: [
      `A possible adverse event or outcome`,
      `To incur risk of (something).`,
    ],
  },
  {
    word: `current`,
    wordInfo: [
      `The generally unidirectional movement of a gas or fluid.`,
      `Existing or occurring at the moment`,
    ],
  },
  {
    word: `fire`,
    wordInfo: [
      `A (usually self-sustaining) chemical reaction involving the bonding of oxygen with carbon or other fuel, with the production of heat and the presence of flame or smouldering.`,
      `To set (something, often a building) on fire.`,
    ],
  },
  {
    word: `future`,
    wordInfo: [
      `The time ahead; those moments yet to be experienced.`,
      `Having to do with or occurring in the future.`,
    ],
  },
  {
    word: `wrong`,
    wordInfo: [
      `Something that is immoral or not good.`,
      `To treat unjustly; to injure or harm.`,
    ],
  },
  {
    word: `involve`,
    wordInfo: [`To roll or fold up; to wind round; to entwine.`],
  },
  {
    word: `defense`,
    wordInfo: [
      `The action of defending or protecting from attack, danger, or injury.`,
    ],
  },
  { word: `anyone`, wordInfo: [`Any person; anybody.`] },
  {
    word: `increase`,
    wordInfo: [
      `An amount by which a quantity is increased.`,
      `(of a quantity, etc.) To become larger or greater.`,
    ],
  },
  {
    word: `security`,
    wordInfo: [
      `The condition of not being threatened, especially physically, psychologically, emotionally, or financially.`,
    ],
  },
  {
    word: `bank`,
    wordInfo: [
      `An institution where one can place and borrow money and take care of financial affairs.`,
      `An edge of river, lake, or other watercourse.`,
      `To deal with a bank or financial institution, or for an institution to provide financial services to a client.`,
      `To roll or incline laterally in order to turn.`,
    ],
  },
  {
    word: `myself`,
    wordInfo: [
      `(reflexive pronoun) Me, as direct or indirect object the speaker as the object of a verb or preposition, when the speaker is also the subject.`,
    ],
  },
  {
    word: `certainly`,
    wordInfo: [`In a way which is certain; with certainty.`],
  },
  {
    word: `west`,
    wordInfo: [
      `One of the four principal compass points, specifically 270�, conventionally directed to the left on maps; the direction of the setting sun at an equinox, abbreviated as W.`,
      `To move to the west; (of the sun) to set.`,
    ],
  },
  {
    word: `sport`,
    wordInfo: [
      `Any activity that uses physical exertion or skills competitively under a set of rules that is not based on aesthetics.`,
      `To amuse oneself, to play.`,
    ],
  },
  {
    word: `board`,
    wordInfo: [
      `A relatively long, wide and thin piece of any material, usually wood or similar, often for use in construction or furniture-making.`,
      `A rebound.`,
      `To step or climb onto or otherwise enter a ship, aircraft, train or other conveyance.`,
    ],
  },
  {
    word: `seek`,
    wordInfo: [
      `The operation of navigating through a stream.`,
      `To try to find; to look for; to search for.`,
    ],
  },
  {
    word: `per`,
    wordInfo: [
      `For each.`,
      `Belonging to per, their (singular). Gender-neutral third-person singular possessive adjective, coordinate with gendered his and her.`,
    ],
  },
  {
    word: `subject`,
    wordInfo: [
      `Likely to be affected by or to experience something.`,
      `(grammar) In a clause: the word or word group (usually a noun phrase) that is dealt with. In active clauses with verbs denoting an action, the subject and the actor are usually the same.`,
    ],
  },
  {
    word: `officer`,
    wordInfo: [
      `One who has a position of authority in a hierarchical organization, especially in military, police or government organizations.`,
      `To supply with officers.`,
    ],
  },
  {
    word: `private`,
    wordInfo: [
      `A soldier of the lowest rank in the army.`,
      `Belonging to, concerning, or accessible only to an individual person or a specific group.`,
    ],
  },
  {
    word: `rest`,
    wordInfo: [
      `(of a person or animal) Relief from work or activity by sleeping; sleep.`,
      `To cease from action, motion, work, or performance of any kind; stop; desist; be without motion.`,
    ],
  },
  { word: `behavior`, wordInfo: [`Human conduct relative to social norms.`] },
  {
    word: `deal`,
    wordInfo: [
      `A division, a portion, a share.`,
      `An act of dealing or sharing out.`,
    ],
  },
  {
    word: `performance`,
    wordInfo: [
      `The act of performing; carrying into execution or action; execution; achievement; accomplishment; representation by action.`,
    ],
  },
  {
    word: `fight`,
    wordInfo: [
      `To contend in physical conflict, either singly or in war, battle etc.`,
      `An occasion of fighting.`,
    ],
  },
  {
    word: `throw`,
    wordInfo: [
      `To change place.`,
      `The flight of a thrown object.`,
      `Pain, especially pain associated with childbirth; throe.`,
      `(said of animals) To give birth to.`,
    ],
  },
  {
    word: `top`,
    wordInfo: [
      `The highest or uppermost part of something.`,
      `To cover on the top or with a top.`,
    ],
  },
  { word: `quickly`, wordInfo: [`Rapidly; with speed; fast.`] },
  {
    word: `past`,
    wordInfo: [
      `To change place.`,
      `The period of time that has already happened, in contrast to the present and the future.`,
    ],
  },
  {
    word: `goal`,
    wordInfo: [
      `A result that one is attempting to achieve.`,
      `To score a goal.`,
    ],
  },
  {
    word: `second`,
    wordInfo: [
      `Something that is number two in a series.`,
      `To agree as a second person to (a proposal), usually to reach a necessary quorum of two. (See under #Etymology 3 for translations.)`,
      `One-sixtieth of a minute; the SI unit of time, defined as the duration of 9,192,631,770 periods of radiation corresponding to the transition between two hyperfine levels of caesium-133 in a ground state at a temperature of absolute zero and at rest.`,
    ],
  },
  {
    word: `bed`,
    wordInfo: [
      `A piece of furniture, usually flat and soft, on which to rest or sleep.`,
      `Senses relating to a bed as a place for resting or sleeping.`,
    ],
  },
  {
    word: `order`,
    wordInfo: [
      `Arrangement, disposition, or sequence.`,
      `To set in some sort of order.`,
    ],
  },
  {
    word: `author`,
    wordInfo: [
      `The originator or creator of a work, especially of a literary composition.`,
      `(sometimes proscribed) To create a work as its author.`,
    ],
  },
  {
    word: `fill`,
    wordInfo: [
      `To occupy fully, to take up all of.`,
      `(after a possessive) A sufficient or more than sufficient amount.`,
    ],
  },
  {
    word: `represent`,
    wordInfo: [
      `To present again or anew; to present by means of something standing in the place of; to exhibit the counterpart or image of; to typify.`,
    ],
  },
  {
    word: `focus`,
    wordInfo: [
      `A point at which reflected or refracted rays of light converge.`,
      `(followed by on or upon) To concentrate one's attention.`,
    ],
  },
  {
    word: `foreign`,
    wordInfo: [
      `A foreign person, particularly:`,
      `Located outside a country or place, especially one's own.`,
    ],
  },
  {
    word: `drop`,
    wordInfo: [
      `A small quantity of liquid, just large enough to hold its own round shape via surface tension, especially one that falls from a source of liquid.`,
      `To fall in droplets (of a liquid).`,
    ],
  },
  {
    word: `plan`,
    wordInfo: [
      `A drawing showing technical details of a building, machine, etc., with unwanted details omitted, and often using symbols rather than detailed drawing to represent doors, valves, etc.`,
      `To design (a building, machine, etc.).`,
    ],
  },
  {
    word: `blood`,
    wordInfo: [
      `A member of the Los Angeles gang The Bloods.`,
      `A vital liquid flowing in the bodies of many types of animals that usually conveys nutrients and oxygen. In vertebrates, it is colored red by hemoglobin, is conveyed by arteries and veins, is pumped by the heart and is usually generated in bone marrow.`,
    ],
  },
  {
    word: `upon`,
    wordInfo: [
      `Being the target of an action.`,
      `Physically above and in contact with.`,
    ],
  },
  {
    word: `agency`,
    wordInfo: [
      `The capacity, condition, or state of acting or of exerting power.`,
    ],
  },
  {
    word: `push`,
    wordInfo: [
      `A short, directed application of force; an act of pushing.`,
      `A pustule; a pimple.`,
      `To apply a force to (an object) such that it moves away from the person or thing applying the force.`,
    ],
  },
  {
    word: `nature`,
    wordInfo: [
      `The natural world; that which consists of all things unaffected by or predating human technology, production, and design. (Compare ecosystem.)`,
      `To endow with natural qualities.`,
    ],
  },
  {
    word: `color`,
    wordInfo: [
      `The spectral composition of visible light`,
      `To give something color.`,
    ],
  },
  {
    word: `no`,
    wordInfo: [
      `A negating expression; an answer that shows disagreement or disapproval`,
      `(now only used with different, with comparatives more and less, and informally with certain other adjectives such as good and fun) Not, not at all.`,
      `At or towards the interior of a defined space, such as a building or room.`,
      `An abstract entity used to describe quantity.`,
    ],
  },
  { word: `recently`, wordInfo: [`In the recent past`] },
  {
    word: `store`,
    wordInfo: [
      `A place where items may be accumulated or routinely kept.`,
      `To keep (something) while not in use, generally in a place meant for that purpose.`,
    ],
  },
  {
    word: `reduce`,
    wordInfo: [
      `To bring down the size, quantity, quality, value or intensity of something; to diminish, to lower.`,
    ],
  },
  {
    word: `sound`,
    wordInfo: [
      `Healthy.`,
      `Soundly.`,
      `A sensation perceived by the ear caused by the vibration of air or some other medium.`,
      `To produce a sound.`,
    ],
  },
  {
    word: `note`,
    wordInfo: [
      `(heading) A symbol or annotation.`,
      `That which is needed or necessary; business; duty; work.`,
      `To notice with care; to observe; to remark; to heed.`,
    ],
  },
  {
    word: `fine`,
    wordInfo: [
      `Fine champagne; French brandy.`,
      `To make finer, purer, or cleaner; to purify or clarify.`,
      `A fee levied as punishment for breaking the law.`,
      `To issue a fine as punishment to (someone).`,
    ],
  },
  {
    word: `before`,
    wordInfo: [`At an earlier time.`, `Earlier than (in time).`],
  },
  {
    word: `near`,
    wordInfo: [
      `The left side of a horse or of a team of horses pulling a carriage etc.`,
      `To come closer to; to approach.`,
    ],
  },
  { word: `movement`, wordInfo: [`Physical motion between points in space.`] },
  {
    word: `page`,
    wordInfo: [
      `One of the many pieces of paper bound together within a book or similar document.`,
      `A serving boy � a youth attending a person of high degree, especially at courts, as a position of honor and education.`,
      `To mark or number the pages of, as a book or manuscript.`,
      `To attend (someone) as a page.`,
    ],
  },
  {
    word: `enter`,
    wordInfo: [
      'The `Enter` key on a computer keyboard.',
      `To go or come into an enclosed or partially enclosed space.`,
    ],
  },
  {
    word: `share`,
    wordInfo: [
      `A portion of something, especially a portion given or allotted to someone.`,
      `The cutting blade of an agricultural machine like a plough, a cultivator or a seeding-machine.`,
      `To give part of what one has to somebody else to use or consume.`,
      `To cut; to shear; to cleave; to divide.`,
    ],
  },
  {
    word: `than`,
    wordInfo: [
      `At that time; then.`,
      `Introduces a comparison, and is associated with comparatives, and with words such as more, less, and fewer. Typically, it seeks to measure the force of an adjective or similar description between two predicates.`,
    ],
  },
  {
    word: `common`,
    wordInfo: [
      `Mutual good, shared by more than one.`,
      `To communicate (something).`,
    ],
  },
  {
    word: `poor`,
    wordInfo: [
      '(with `the`) Those who have little or no possessions or money, taken as a group.',
      `With no or few possessions or money, particularly in relation to contemporaries who do have them.`,
    ],
  },
  {
    word: `other`,
    wordInfo: [
      `An other, another (person, etc), more often rendered as another.`,
      'To regard, label or treat as an `other`, as not part of the same group; to view as different and alien.',
    ],
  },
  {
    word: `natural`,
    wordInfo: [
      `A native inhabitant of a place, country etc.`,
      `That exists and evolved within the confines of an ecosystem.`,
    ],
  },
  {
    word: `race`,
    wordInfo: [
      `A contest between people, animals, vehicles, etc. where the goal is to be the first to reach some objective. Example: Several horses run in a horse race, and the first one to reach the finishing post wins`,
      `A group of sentient beings, particularly people, distinguished by common ancestry, heritage or characteristics:`,
      `To take part in a race (in the sense of a contest).`,
      `To assign a race to; to perceive as having a (usually specified) race.`,
    ],
  },
  {
    word: `concern`,
    wordInfo: [
      `That which affects one�s welfare or happiness. A matter of interest to someone. The adposition before the matter of interest is usually over, about or for.`,
      `To relate or belong to; to have reference to or connection with; to affect the interest of; to be of importance to.`,
    ],
  },
  {
    word: `series`,
    wordInfo: [
      `A number of things that follow on one after the other or are connected one after the other.`,
      `Connected one after the other in a circuit.`,
    ],
  },
  {
    word: `significant`,
    wordInfo: [
      `That which has significance; a sign; a token; a symbol.`,
      `Signifying something; carrying meaning.`,
    ],
  },
  {
    word: `similar`,
    wordInfo: [
      `That which is similar to, or resembles, something else, as in quality, form, etc.`,
      `Having traits or characteristics in common; alike, comparable.`,
    ],
  },
  {
    word: `hot`,
    wordInfo: [
      `(with up) To heat; to make or become hot.`,
      `(of an object) Having a high temperature.`,
    ],
  },
  {
    word: `language`,
    wordInfo: [
      `A body of words, and set of methods of combining them (called a grammar), understood by a community and used as a form of communication.`,
      `A languet, a flat plate in or below the flue pipe of an organ.`,
      `To communicate by language; to express in language.`,
    ],
  },
  {
    word: `each`,
    wordInfo: [
      `(operations) An individual item: the least quantitative unit in a grouping.`,
      `For one; apiece; per.`,
    ],
  },
  {
    word: `usually`,
    wordInfo: [
      `Most of the time; less than always, but more than occasionally.`,
    ],
  },
  {
    word: `response`,
    wordInfo: [
      `An answer or reply, or something in the nature of an answer or reply.`,
    ],
  },
  {
    word: `dead`,
    wordInfo: [
      '(with `the`, a demonstrative, or a possessive) Those who have died.',
      '(often with `the`) Time when coldness, darkness, or stillness is most intense.',
    ],
  },
  {
    word: `rise`,
    wordInfo: [
      `To move, or appear to move, physically upwards relative to the ground.`,
      `The process of or an action or instance of moving upwards or becoming greater.`,
    ],
  },
  {
    word: `animal`,
    wordInfo: [
      `In scientific usage, a multicellular organism that is usually mobile, whose cells are not encased in a rigid cell wall (distinguishing it from plants and fungi) and which derives energy solely from the consumption of other organisms (distinguishing it from plants).`,
      `Of or relating to animals.`,
    ],
  },
  {
    word: `factor`,
    wordInfo: [
      `A doer, maker; a person who does things for another person or organization.`,
      `To find all the factors of (a number or other mathematical object) (the objects that divide it evenly).`,
    ],
  },
  {
    word: `decade`,
    wordInfo: [`A group, set, or series of ten , particularly:`],
  },
  {
    word: `article`,
    wordInfo: [
      `A piece of nonfictional writing such as a story, report, opinion piece, or entry in a newspaper, magazine, journal, dictionary, encyclopedia, etc.`,
      `To bind by articles of apprenticeship.`,
    ],
  },
  {
    word: `shoot`,
    wordInfo: [
      `The emerging stem and embryonic leaves of a new plant.`,
      `A mild expletive, expressing disbelief or disdain`,
      `To launch a projectile.`,
    ],
  },
  {
    word: `east`,
    wordInfo: [
      `One of the four principal compass points, specifically 90�, conventionally directed to the right on maps; the direction of the rising sun at an equinox. Abbreviated as E.`,
      `Situated or lying in or towards the east; eastward.`,
    ],
  },
  {
    word: `save`,
    wordInfo: [
      `In various sports, a block that prevents an opponent from scoring.`,
      `To prevent harm or difficulty.`,
    ],
  },
  {
    word: `seven`,
    wordInfo: [
      `The digit/figure 7 or an occurrence thereof.`,
      `A numerical value equal to 7; the number following six and preceding eight. This many dots: (�������).`,
    ],
  },
  { word: `artist`, wordInfo: [`A person who creates art.`, `Artistic.`] },
  {
    word: `away`,
    wordInfo: [
      `To depart; to go to another place.`,
      `Not here, gone, absent, unavailable, traveling; on vacation.`,
    ],
  },
  {
    word: `scene`,
    wordInfo: [
      `The location of an event that attracts attention.`,
      `To exhibit as a scene; to make a scene of; to display.`,
    ],
  },
  {
    word: `stock`,
    wordInfo: [
      `A store or supply.`,
      `To have on hand for sale.`,
      `A thrust with a rapier; a stoccado.`,
    ],
  },
  {
    word: `career`,
    wordInfo: [
      `One's calling in life; a person's occupation; one's profession.`,
      `To move rapidly straight ahead, especially in an uncontrolled way.`,
    ],
  },
  {
    word: `despite`,
    wordInfo: [
      `Disdain, contemptuous feelings, hatred.`,
      `To vex; to annoy; to offend contemptuously.`,
    ],
  },
  { word: `central`, wordInfo: [`Being in the centre.`] },
  {
    word: `eight`,
    wordInfo: [
      `The digit/figure 8.`,
      `A numerical value equal to 8; the number occurring after seven and before nine.`,
      `An island in a river, especially the River Thames in England.`,
    ],
  },
  {
    word: `thus`,
    wordInfo: [
      `(manner) In this way or manner.`,
      `Frankincense obtained from conifers such as the Norway spruce, or long-leaved pine.`,
    ],
  },
  {
    word: `treatment`,
    wordInfo: [`The process or manner of treating someone or something.`],
  },
  { word: `beyond`, wordInfo: [`The unknown.`, `Farther along or away.`] },
  {
    word: `happy`,
    wordInfo: [
      `A happy event, thing, person, etc.`,
      `Preceded by the: happy people as a group.`,
    ],
  },
  {
    word: `exactly`,
    wordInfo: [
      `(manner) without approximation; precisely.`,
      `Signifies agreement or recognition.`,
    ],
  },
  {
    word: `protect`,
    wordInfo: [`To keep safe; to defend; to guard; to prevent harm coming to.`],
  },
  {
    word: `approach`,
    wordInfo: [
      `The act of drawing near; a coming or advancing near.`,
      `To come or go near, in place or time; to draw nigh; to advance nearer.`,
    ],
  },
  {
    word: `lie`,
    wordInfo: [
      `The terrain and conditions surrounding the ball before it is struck.`,
      `To give false information intentionally with intent to deceive.`,
      `To rest in a horizontal position on a surface.`,
    ],
  },
  {
    word: `size`,
    wordInfo: [
      `(obsolete outside dialectal) An assize.`,
      `A thin, weak glue used as primer for paper or canvas intended to be painted upon.`,
      `To adjust the size of; to make a certain size.`,
      `To apply glue or other primer to a surface which is to be painted.`,
    ],
  },
  {
    word: `dog`,
    wordInfo: [
      `A mammal, Canis familiaris or Canis lupus familiaris, that has been domesticated for thousands of years, of highly variable appearance due to human breeding.`,
      `To pursue with the intent to catch.`,
    ],
  },
  { word: `fund`, wordInfo: [`A sum or source of money.`, `To pay for.`] },
  {
    word: `serious`,
    wordInfo: [
      `Without humor or expression of happiness; grave in manner or disposition`,
      `In a serious manner; seriously.`,
    ],
  },
  { word: `occur`, wordInfo: [`To happen or take place.`] },
  {
    word: `media`,
    wordInfo: [
      `The middle layer of the wall of a blood vessel or lymph vessel which is composed of connective and muscular tissue.`,
      `Means and institutions for publishing and broadcasting information.`,
    ],
  },
  {
    word: `ready`,
    wordInfo: [`Ready money; cash`, `To prepare; to make ready for action.`],
  },
  {
    word: `sign`,
    wordInfo: [
      `(sometimes also used uncountably) A visible indication.`,
      `To make a mark`,
    ],
  },
  {
    word: `thought`,
    wordInfo: [`To ponder, to go over in one's head.`, `To seem, to appear.`],
  },
  {
    word: `list`,
    wordInfo: [
      `A strip of fabric, especially from the edge of a piece of cloth.`,
      `Art; craft; cunning; skill.`,
      `To create or recite a list.`,
    ],
  },
  {
    word: `individual`,
    wordInfo: [
      `A person considered alone, rather than as belonging to a group of people.`,
      `Relating to a single person or thing as opposed to more than one.`,
    ],
  },
  {
    word: `simple`,
    wordInfo: [
      `A herbal preparation made from one plant, as opposed to something made from more than one plant.`,
      `To gather simples, i.e. medicinal herbs.`,
    ],
  },
  {
    word: `quality`,
    wordInfo: [
      `Level of excellence.`,
      `Being of good worth, well made, fit for purpose.`,
    ],
  },
  {
    word: `pressure`,
    wordInfo: [
      `A pressing; a force applied to a surface.`,
      `To encourage or heavily exert force or influence.`,
    ],
  },
  {
    word: `accept`,
    wordInfo: [
      `To receive, especially with a consent, with favour, or with approval.`,
      `Accepted.`,
    ],
  },
  {
    word: `answer`,
    wordInfo: [
      `A response or reply; something said or done in reaction to a statement or question.`,
      `To make a reply or response to.`,
    ],
  },
  {
    word: `hard`,
    wordInfo: [
      `A firm or paved beach or slope convenient for hauling vessels out of the water.`,
      `(of material or fluid) Having a severe property; presenting difficulty.`,
    ],
  },
  {
    word: `resource`,
    wordInfo: [
      `Something that one uses to achieve an objective, e.g. raw materials or personnel.`,
      `To supply with resources.`,
    ],
  },
  {
    word: `identify`,
    wordInfo: [`To establish the identity of someone or something.`],
  },
  {
    word: `left`,
    wordInfo: [
      `The left side or direction.`,
      `The opposite of right; toward the west when one is facing north.`,
      `To have a consequence or remnant.`,
      `To give leave to; allow; permit; let; grant.`,
    ],
  },
  {
    word: `meeting`,
    wordInfo: [
      `(gerund) The act of persons or things that meet.`,
      `To make contact (with) while in proximity.`,
    ],
  },
  { word: `determine`, wordInfo: [`To set the boundaries or limits of.`] },
  {
    word: `prepare`,
    wordInfo: [
      `Preparation`,
      `To make ready for a specific future purpose; to set up; to assemble or equip.`,
    ],
  },
  {
    word: `disease`,
    wordInfo: [
      `An abnormal condition of a human, animal or plant that causes discomfort or dysfunction; distinct from injury insofar as the latter is usually instantaneously acquired.`,
      `To cause unease; to annoy, irritate.`,
    ],
  },
  {
    word: `whatever`,
    wordInfo: [
      `Unexceptional or unimportant; blah.`,
      `No matter what; for any`,
    ],
  },
  { word: `success`, wordInfo: [`The achievement of one's aim or goal.`] },
  {
    word: `argue`,
    wordInfo: [`To show grounds for concluding (that); to indicate, imply.`],
  },
  {
    word: `cup`,
    wordInfo: [
      `A concave vessel for drinking from, usually made of opaque material (as opposed to a glass) and with a handle.`,
      `To form into the shape of a cup, particularly of the hands.`,
    ],
  },
  { word: `particularly`, wordInfo: [`(focus) Especially, extremely.`] },
  {
    word: `amount`,
    wordInfo: [
      `The total, aggregate or sum of material (not applicable to discrete numbers or units or items in standard English).`,
      `(followed by to) To total or evaluate.`,
    ],
  },
  { word: `ability`, wordInfo: [`Suitableness.`] },
  {
    word: `staff`,
    wordInfo: [
      `(plural staffs or staves) A long, straight, thick wooden rod or stick, especially one used to assist in walking.`,
      `To supply (a business, volunteer organization, etc.) with employees or staff members.`,
    ],
  },
  {
    word: `recognize`,
    wordInfo: [
      `To match (something or someone which one currently perceives) to a memory of some previous encounter with the same person or thing.`,
      `To cognize again`,
    ],
  },
  {
    word: `indicate`,
    wordInfo: [
      `To point out; to discover; to direct to a knowledge of; to show; to make known.`,
    ],
  },
  {
    word: `character`,
    wordInfo: [
      `A being involved in the action of a story.`,
      `To write (using characters); to describe.`,
    ],
  },
  {
    word: `growth`,
    wordInfo: [`An increase in size, number, value, or strength.`],
  },
  {
    word: `loss`,
    wordInfo: [
      `The result of no longer possessing an object, a function, or a characteristic due to external causes or misplacement.`,
    ],
  },
  {
    word: `degree`,
    wordInfo: [
      `A stage of proficiency or qualification in a course of study, now especially an award bestowed by a university or, in some countries, a college, as a certification of academic achievement. (In the United States, can include secondary schools.)`,
    ],
  },
  {
    word: `wonder`,
    wordInfo: [
      `Something that causes amazement or awe; a marvel.`,
      `To be affected with surprise or admiration; to be struck with astonishment; to be amazed; to marvel; often followed by at.`,
    ],
  },
  {
    word: `attack`,
    wordInfo: [
      `An attempt to cause damage, injury to, or death of opponent or enemy.`,
      `To apply violent force to someone or something.`,
    ],
  },
  {
    word: `herself`,
    wordInfo: [
      `(reflexive pronoun) Her; the female object of a verb or preposition that also appears as the subject.`,
    ],
  },
  {
    word: `region`,
    wordInfo: [
      `Any considerable and connected part of a space or surface; specifically, a tract of land or sea of considerable but indefinite extent; a country; a district; in a broad sense, a place without special reference to location or extent but viewed as an entity for geographical, social or cultural reasons.`,
    ],
  },
  {
    word: `television`,
    wordInfo: [
      `An electronic communication medium that allows the transmission of real-time visual images, and often sound.`,
      `To watch television.`,
    ],
  },
  {
    word: `box`,
    wordInfo: [
      `Senses relating to a three-dimensional object or space.`,
      `Any of various evergreen shrubs or trees of the genus Buxus, especially the common box, European box, or boxwood (Buxus sempervirens) which is often used for making hedges and topiary.`,
      `To place inside a box; to pack in one or more boxes.`,
    ],
  },
  {
    word: `TV`,
    wordInfo: [
      `The assessed value of an asset from which the tax owing is computed.`,
      `An electronic communication medium that allows the transmission of real-time visual images, and often sound.`,
    ],
  },
  {
    word: `training`,
    wordInfo: [`To practice an ability.`, `Action of the verb to train.`],
  },
  {
    word: `pretty`,
    wordInfo: [
      `A pretty person; a term of address to a pretty person.`,
      `To make pretty; to beautify`,
    ],
  },
  {
    word: `trade`,
    wordInfo: [
      `Buying and selling of goods and services on a market.`,
      `To engage in trade.`,
    ],
  },
  {
    word: `deal`,
    wordInfo: [
      `A division, a portion, a share.`,
      `An act of dealing or sharing out.`,
    ],
  },
  {
    word: `election`,
    wordInfo: [
      `A process of choosing a leader, members of parliament, councillors or other representatives by popular vote.`,
    ],
  },
  { word: `everybody`, wordInfo: [`All people.`] },
  { word: `physical`, wordInfo: [`Physical examination.`, `Of medicine.`] },
  {
    word: `lay`,
    wordInfo: [
      `Arrangement or relationship; layout.`,
      `A lake.`,
      `To place down in a position of rest, or in a horizontal position.`,
    ],
  },
  {
    word: `general`,
    wordInfo: [
      `A general fact or proposition; a generality.`,
      `To lead (soldiers) as a general.`,
    ],
  },
  {
    word: `feeling`,
    wordInfo: [
      `(heading) To use or experience the sense of touch.`,
      `Sensation, particularly through the skin.`,
    ],
  },
  {
    word: `standard`,
    wordInfo: [
      `A principle or example or measure used for comparison.`,
      `Falling within an accepted range of size, amount, power, quality, etc.`,
    ],
  },
  {
    word: `bill`,
    wordInfo: [
      `Any of various bladed or pointed hand weapons, originally designating an Anglo-Saxon sword, and later a weapon of infantry, especially in the 14th and 15th centuries, commonly consisting of a broad, heavy, double-edged, hook-shaped blade, with a short pike at the back and another at the top, attached to the end of a long staff.`,
      `The beak of a bird, especially when small or flattish; sometimes also used with reference to a platypus, turtle, or other animal.`,
      `To dig, chop, etc., with a bill.`,
      `To peck`,
    ],
  },
  {
    word: `message`,
    wordInfo: [
      `A communication, or what is communicated; any concept or information conveyed.`,
      `To send a message to; to transmit a message to, e.g. as text via a cell phone.`,
    ],
  },
  {
    word: `fail`,
    wordInfo: [
      `Poor quality; substandard workmanship.`,
      `To be unsuccessful.`,
      `A piece of turf cut from grassland.`,
    ],
  },
  {
    word: `outside`,
    wordInfo: [
      `The part of something that faces out; the outer surface.`,
      `Of or pertaining to the outer surface, limit or boundary.`,
    ],
  },
  { word: `arrive`, wordInfo: [`To reach; to get to a certain place.`] },
  {
    word: `analysis`,
    wordInfo: [
      `Decomposition into components in order to study (a complex thing, concept, theory etc.).`,
    ],
  },
  {
    word: `benefit`,
    wordInfo: [
      `An advantage; help or aid from something.`,
      `To be or to provide a benefit to.`,
    ],
  },
  {
    word: `name`,
    wordInfo: [
      `Any nounal word or phrase which indicates a particular person, place, class, or thing.`,
      `(ditransitive) To give a name to.`,
    ],
  },
  {
    word: `sex`,
    wordInfo: [
      `A category into which sexually-reproducing organisms are divided on the basis of their reproductive roles in their species.`,
      `An offshoot of a larger religion; a group sharing particular (often unorthodox) political and/or religious beliefs.`,
      `To determine the sex of an animal.`,
    ],
  },
  {
    word: `forward`,
    wordInfo: [
      `One of the eight players (comprising two props, one hooker, two locks, two flankers and one number eight, collectively known as the pack) whose primary task is to gain and maintain possession of the ball (compare back).`,
      `To advance, promote.`,
      `An introductory section preceding the main text of a book or other document; a preface or introduction.`,
      `Agreement; covenant.`,
    ],
  },
  {
    word: `lawyer`,
    wordInfo: [
      `A professional person qualified (as by a law degree or bar exam) and authorized to practice law, i.e. represent parties in lawsuits or trials and give legal advice.`,
      `To practice law.`,
    ],
  },
  {
    word: `present`,
    wordInfo: [
      `The current moment or period of time.`,
      `A gift, especially one given for birthdays, Christmas, anniversaries, graduations, weddings, or any other special occasions.`,
      `Relating to now, for the time being; current.`,
      `To bring (someone) into the presence of (a person); to introduce formally.`,
    ],
  },
  {
    word: `section`,
    wordInfo: [
      `A cutting; a part cut out from the rest of something.`,
      `To cut, divide or separate into pieces.`,
    ],
  },
  { word: `environmental`, wordInfo: [`Pertaining to the environment.`] },
  {
    word: `glass`,
    wordInfo: [
      `To apply fibreglass to.`,
      `An amorphous solid, often transparent substance made by melting sand with a mixture of soda, potash and lime.`,
    ],
  },
  {
    word: `answer`,
    wordInfo: [
      `A response or reply; something said or done in reaction to a statement or question.`,
      `To make a reply or response to.`,
    ],
  },
  {
    word: `skill`,
    wordInfo: [
      `Capacity to do something well; technique, ability. Skills are usually acquired or learned, as opposed to abilities, which are often thought of as innate.`,
      `To set apart; separate.`,
      `Great, excellent.`,
    ],
  },
  {
    word: `sister`,
    wordInfo: [
      `A daughter of the same parents as another person; a female sibling.`,
      `To strengthen (a supporting beam) by fastening a second beam alongside it.`,
    ],
  },
  {
    word: `PM`,
    wordInfo: [
      `After noon (used after a time to indicate it is between noon and midnight, i.e., in the afternoon, evening or night as opposed to the morning)`,
      `After death`,
    ],
  },
  {
    word: `professor`,
    wordInfo: [
      'The most senior rank for an academic at a university or similar institution, informally also known as `full professor.` Abbreviated Prof.',
    ],
  },
  {
    word: `operation`,
    wordInfo: [`The method by which a device performs its function.`],
  },
  { word: `financial`, wordInfo: [`Related to finances.`] },
  {
    word: `crime`,
    wordInfo: [
      `A specific act committed in violation of the law.`,
      `To subject to disciplinary punishment.`,
    ],
  },
  {
    word: `stage`,
    wordInfo: [`A phase.`, `To produce on a stage, to perform a play.`],
  },
  { word: `ok`, wordInfo: [`All right, permitted.`] },
  {
    word: `compare`,
    wordInfo: [
      `Comparison.`,
      'To assess the similarities and differences between two or more things [`to compare X with Y`]. Having made the comparison of X with Y, one might have found it similar to Y or different from Y.',
    ],
  },
  {
    word: `authority`,
    wordInfo: [`The power to enforce rules or give orders.`],
  },
  {
    word: `miss`,
    wordInfo: [
      `A failure to hit.`,
      `A title of respect for a young woman (usually unmarried) with or without a name used.`,
      `To fail to hit.`,
    ],
  },
  {
    word: `design`,
    wordInfo: [
      `A specification of an object or process, referring to requirements to be satisfied and thus conditions to be met for them to solve a problem.`,
      `To plan and carry out (a picture, work of art, construction etc.).`,
    ],
  },
  {
    word: `sort`,
    wordInfo: [
      `A general type.`,
      `To separate items into different categories according to certain criteria that determine their sorts.`,
    ],
  },
  {
    word: `one`,
    wordInfo: [
      `The digit or figure 1.`,
      `To cause to become one; to gather into a single whole; to unite.`,
    ],
  },
  { word: `act`, wordInfo: [`Something done, a deed.`, `To do something.`] },
  {
    word: `ten`,
    wordInfo: [
      `A set or group with ten elements.`,
      `The number occurring after nine and before eleven, represented in Arabic numerals (base ten) as 10 and in Roman numerals as X.`,
    ],
  },
  {
    word: `knowledge`,
    wordInfo: [
      `The fact of knowing about something; general understanding or familiarity with a subject, place, situation etc.`,
      `To confess as true; to acknowledge.`,
    ],
  },
  {
    word: `gun`,
    wordInfo: [
      `A device for projecting a hard object very forcefully; a firearm or cannon.`,
      `Nonstandard spelling of going to.`,
      `(with �down�) To shoot someone or something, usually with a firearm.`,
    ],
  },
  {
    word: `station`,
    wordInfo: [
      `A stopping place.`,
      `(usually passive) To put in place to perform a task.`,
    ],
  },
  {
    word: `blue`,
    wordInfo: [
      `The colour of the clear sky or the deep sea, between green and violet in the visible spectrum, and one of the primary additive colours for transmitted light; the colour obtained by subtracting red and green from white light using magenta and cyan filters; or any colour resembling this.`,
      `To make or become blue.`,
      `(entertainment) Pornographic or profane.`,
    ],
  },
  {
    word: `state`,
    wordInfo: [
      `A condition; a set of circumstances applying at any given time.`,
      `To declare to be a fact.`,
    ],
  },
  {
    word: `strategy`,
    wordInfo: [
      `The science and art of military command as applied to the overall planning and conduct of warfare.`,
    ],
  },
  { word: `little`, wordInfo: [`A small amount.`, `Small in size.`] },
  { word: `clearly`, wordInfo: [`(manner) In a clear manner.`] },
  {
    word: `discuss`,
    wordInfo: [`To converse or debate concerning a particular topic.`],
  },
  {
    word: `indeed`,
    wordInfo: [
      `(modal) Truly; in fact; actually.`,
      `Indicates emphatic agreement.`,
    ],
  },
  {
    word: `force`,
    wordInfo: [
      `Strength or energy of body or mind; active power; vigour; might; capacity of exercising an influence or producing an effect.`,
      `To violate (a woman); to rape.`,
      `A waterfall or cascade.`,
    ],
  },
  {
    word: `truth`,
    wordInfo: [
      `True facts, genuine depiction or statements of reality.`,
      `To assert as true; to declare; to speak truthfully.`,
    ],
  },
  {
    word: `song`,
    wordInfo: [
      `A musical composition with lyrics for voice or voices, performed by singing.`,
    ],
  },
  {
    word: `example`,
    wordInfo: [
      `Something that is representative of all such things in a group.`,
      `To be illustrated or exemplified (by).`,
    ],
  },
  {
    word: `democratic`,
    wordInfo: [
      `Pertaining to democracy; favoring democracy, or constructed upon the principle of government by the people.`,
    ],
  },
  {
    word: `check`,
    wordInfo: [
      `A situation in which the king is directly threatened by an opposing piece.`,
      `To inspect; to examine.`,
    ],
  },
  {
    word: `environment`,
    wordInfo: [
      `The surroundings of, and influences on, a particular item of interest.`,
    ],
  },
  {
    word: `leg`,
    wordInfo: [
      `A limb or appendage that an animal uses for support or locomotion.`,
      `Making, or having the power to make, a law or laws; lawmaking`,
      `To remove the legs from an animal carcass.`,
      `A governmental body with the power to make, amend and repeal laws.`,
    ],
  },
  {
    word: `dark`,
    wordInfo: [
      `Having an absolute or (more often) relative lack of light.`,
      `A complete or (more often) partial absence of light.`,
    ],
  },
  {
    word: `public`,
    wordInfo: [
      `The people in general, regardless of membership of any particular group.`,
      `Able to be seen or known by everyone; open to general view, happening without concealment.`,
    ],
  },
  {
    word: `various`,
    wordInfo: [`Having a broad range (of different elements).`],
  },
  {
    word: `rather`,
    wordInfo: [`To prefer; to prefer to.`, `Prior; earlier; former.`],
  },
  {
    word: `laugh`,
    wordInfo: [
      `An expression of mirth particular to the human species; the sound heard in laughing; laughter.`,
      `To show mirth, satisfaction, or derision, by peculiar movement of the muscles of the face, particularly of the mouth, causing a lighting up of the face and eyes, and usually accompanied by the emission of explosive or chuckling sounds from the chest and throat; to indulge in laughter.`,
    ],
  },
  {
    word: `guess`,
    wordInfo: [
      `To reach a partly (or totally) unqualified conclusion.`,
      `A prediction about the outcome of something, typically made without factual evidence or support.`,
    ],
  },
  {
    word: `executive`,
    wordInfo: [
      `A chief officer or administrator, especially one who can make significant decisions on their own authority.`,
      `Designed or fitted for execution, or carrying into effect.`,
    ],
  },
  {
    word: `set`,
    wordInfo: [
      `To put (something) down, to rest.`,
      `A punch for setting nails in wood.`,
    ],
  },
  {
    word: `study`,
    wordInfo: [
      `(usually academic) To review materials already learned in order to make sure one does not forget them, usually in preparation for an examination.`,
      `Mental effort to acquire knowledge or learning.`,
    ],
  },
  {
    word: `prove`,
    wordInfo: [
      `To proofread.`,
      `The process of dough proofing.`,
      `To proofread.`,
      `To demonstrate that something is true or viable; to give proof for.`,
    ],
  },
  {
    word: `hang`,
    wordInfo: [
      `The way in which something hangs.`,
      `Cheap processed ham (cured pork), often made specially for sandwiches.`,
      `To be or remain suspended.`,
    ],
  },
  {
    word: `entire`,
    wordInfo: [
      `The whole of something; the entirety.`,
      `(sometimes postpositive) Whole; complete.`,
    ],
  },
  {
    word: `rock`,
    wordInfo: [
      `A formation of minerals, specifically:`,
      `An act of rocking; a rocking motion; a sway.`,
    ],
  },
  {
    word: `design`,
    wordInfo: [
      `A specification of an object or process, referring to requirements to be satisfied and thus conditions to be met for them to solve a problem.`,
      `To plan and carry out (a picture, work of art, construction etc.).`,
    ],
  },
  {
    word: `enough`,
    wordInfo: [
      `Sufficiently.`,
      `A sufficient or adequate number, amount, etc.`,
    ],
  },
  { word: `forget`, wordInfo: [`To lose remembrance of.`] },
  {
    word: `since`,
    wordInfo: [
      `From a specified time in the past.`,
      `From: referring to a period of time ending in the present and defining it by the point in time at which it started, or the period in which its starting point occurred.`,
    ],
  },
  {
    word: `claim`,
    wordInfo: [
      `A demand of ownership made for something.`,
      `To demand ownership of.`,
    ],
  },
  {
    word: `note`,
    wordInfo: [
      `(heading) A symbol or annotation.`,
      `That which is needed or necessary; business; duty; work.`,
      `To notice with care; to observe; to remark; to heed.`,
    ],
  },
  {
    word: `remove`,
    wordInfo: [
      `The act of removing something.`,
      `To move something from one place to another, especially to take away.`,
    ],
  },
  {
    word: `manager`,
    wordInfo: [
      `A person whose job is to manage something, such as a business, a restaurant, or a sports team.`,
    ],
  },
  {
    word: `help`,
    wordInfo: [
      `Action given to provide assistance; aid.`,
      `To provide assistance to (someone or something).`,
    ],
  },
  {
    word: `close`,
    wordInfo: [
      `An end or conclusion.`,
      `(chiefly Yorkshire) An enclosed field.`,
      `(physical) To remove a gap.`,
      `Closed, shut.`,
    ],
  },
  {
    word: `sound`,
    wordInfo: [
      `Healthy.`,
      `Soundly.`,
      `A sensation perceived by the ear caused by the vibration of air or some other medium.`,
      `To produce a sound.`,
    ],
  },
  {
    word: `enjoy`,
    wordInfo: [`To receive pleasure or satisfaction from something`],
  },
  {
    word: `network`,
    wordInfo: [
      `A fabric or structure of fibrous elements attached to each other at regular intervals.`,
      `To interact socially for the purpose of getting connections or personal advancement.`,
    ],
  },
  {
    word: `legal`,
    wordInfo: [
      `The legal department of a company.`,
      `Relating to the law or to lawyers.`,
    ],
  },
  {
    word: `religious`,
    wordInfo: [
      `A member of a religious order, i.e. a monk or nun.`,
      `Concerning religion.`,
    ],
  },
  {
    word: `cold`,
    wordInfo: [
      `(of a thing) Having a low temperature.`,
      `A condition of low temperature.`,
    ],
  },
  {
    word: `form`,
    wordInfo: [
      `(heading, physical) To do with shape.`,
      `To assume (a certain shape or visible structure).`,
    ],
  },
  {
    word: `final`,
    wordInfo: [
      `A final examination; a test or examination given at the end of a term or class; the test that concludes a class.`,
      `Last; ultimate.`,
    ],
  },
  {
    word: `main`,
    wordInfo: [
      `Short for mainline.`,
      `Of chief or leading importance; prime, principal.`,
      `That which is chief or principal; the chief or main portion; the bulk, the greater part, gross.`,
    ],
  },
  {
    word: `science`,
    wordInfo: [
      `A particular discipline or branch of learning, especially one dealing with measurable or systematic principles rather than intuition or natural ability.`,
      `To cause to become versed in science; to make skilled; to instruct.`,
      `A descendant, especially a first-generation descendant of a distinguished family.`,
    ],
  },
  {
    word: `green`,
    wordInfo: [
      `Having green as its color.`,
      `The colour of growing foliage, as well as other plant cells containing chlorophyll; the colour between yellow and blue in the visible spectrum; one of the primary additive colour for transmitted light; the colour obtained by subtracting red and blue from white light using cyan and yellow filters.`,
    ],
  },
  {
    word: `memory`,
    wordInfo: [
      `The ability of the brain to record information or impressions with the facility of recalling them later at will.`,
    ],
  },
  {
    word: `card`,
    wordInfo: [
      `A playing card.`,
      `Material with embedded short wire bristles.`,
      `To check IDs, especially against a minimum age requirement.`,
      `To use a carding device to disentangle the fibres of wool prior to spinning.`,
    ],
  },
  { word: `above`, wordInfo: [`Heaven.`, `Of heaven; heavenly.`] },
  {
    word: `seat`,
    wordInfo: [
      `Something to be sat upon.`,
      `To put an object into a place where it will rest; to fix; to set firm.`,
    ],
  },
  {
    word: `cell`,
    wordInfo: [
      `A single-room dwelling for a hermit.`,
      `A cellular phone.`,
      `To place or enclose in a cell.`,
    ],
  },
  { word: `establish`, wordInfo: [`To make stable or firm; to confirm.`] },
  {
    word: `nice`,
    wordInfo: [
      `Niceness.`,
      `Pleasant, satisfactory.`,
      `To run a process with a specified (usually lower) priority.`,
    ],
  },
  {
    word: `trial`,
    wordInfo: [
      `An opportunity to test something out; a test.`,
      `To carry out a series of tests on (a new product, procedure etc.) before marketing or implementing it.`,
      `Characterized by having three (usually equivalent) components.`,
    ],
  },
  {
    word: `expert`,
    wordInfo: [
      `A person with extensive knowledge or ability in a given subject.`,
      `Extraordinarily capable or knowledgeable.`,
    ],
  },
  {
    word: `that`,
    wordInfo: [
      `Something being indicated that is there; one of those.`,
      `(degree) To a given extent or degree.`,
    ],
  },
  {
    word: `spring`,
    wordInfo: [
      `To weaken, as a joint, ligament, or muscle, by sudden and excessive exertion, as by wrenching; to overstrain, or stretch injuriously, but without luxation`,
      `An act of springing: a leap, a jump.`,
    ],
  },
  {
    word: `firm`,
    wordInfo: [
      `A business partnership; the name under which it trades.`,
      `To make firm or strong; fix securely.`,
    ],
  },
  {
    word: `Democrat`,
    wordInfo: [
      `A supporter of democracy; an advocate of democratic politics (originally as opposed to the aristocrats in Revolutionary France).`,
    ],
  },
  {
    word: `radio`,
    wordInfo: [
      `The technology that allows for the transmission of sound or other signals by modulation of electromagnetic waves.`,
      `To use two-way radio to transmit (a message) (to another radio or other radio operator).`,
    ],
  },
  {
    word: `visit`,
    wordInfo: [
      `A single act of visiting.`,
      `To habitually go to (someone in distress, sickness etc.) to comfort them. (Now generally merged into later senses, below.)`,
    ],
  },
  {
    word: `management`,
    wordInfo: [
      `Administration; the use of limited resources combined with forecasting, planning, leadership and execution skills to achieve predetermined specific goals.`,
    ],
  },
  {
    word: `care`,
    wordInfo: [
      `Grief, sorrow.`,
      `To be concerned (about), to have an interest (in); to feel concern (about).`,
    ],
  },
  {
    word: `avoid`,
    wordInfo: [`To try not to meet or communicate with (a person); to shun`],
  },
  {
    word: `imagine`,
    wordInfo: [
      `A short fanfic or prompt placing a reader insert in a novel scenario with a character or celebrity.`,
      `To form a mental image of something; to envision or create something in one's mind.`,
    ],
  },
  {
    word: `tonight`,
    wordInfo: [
      `The nighttime of the current day or date; this night.`,
      `During the night following the current day.`,
    ],
  },
  { word: `huge`, wordInfo: [`Very large.`] },
  {
    word: `ball`,
    wordInfo: [
      `A solid or hollow sphere, or roughly spherical mass.`,
      `To form or wind into a ball.`,
      `A formal dance.`,
    ],
  },
  {
    word: `no`,
    wordInfo: [
      `A negating expression; an answer that shows disagreement or disapproval`,
      `(now only used with different, with comparatives more and less, and informally with certain other adjectives such as good and fun) Not, not at all.`,
      `At or towards the interior of a defined space, such as a building or room.`,
      `An abstract entity used to describe quantity.`,
    ],
  },
  {
    word: `close`,
    wordInfo: [
      `An end or conclusion.`,
      `(chiefly Yorkshire) An enclosed field.`,
      `(physical) To remove a gap.`,
      `Closed, shut.`,
    ],
  },
  {
    word: `finish`,
    wordInfo: [`An end; the end of anything.`, `To complete (something).`],
  },
  {
    word: `yourself`,
    wordInfo: [`(reflexive pronoun) Your own self (singular).`],
  },
  {
    word: `talk`,
    wordInfo: [
      `To communicate, usually by means of speech.`,
      `A conversation or discussion; usually serious, but informal.`,
    ],
  },
  {
    word: `theory`,
    wordInfo: [
      `A description of an event or system that is considered to be accurate.`,
    ],
  },
  {
    word: `impact`,
    wordInfo: [
      `The striking of one body against another; collision.`,
      `To collide or strike, the act of impinging.`,
    ],
  },
  {
    word: `respond`,
    wordInfo: [
      `A response.`,
      `To say something in return; to answer; to reply.`,
    ],
  },
  {
    word: `statement`,
    wordInfo: [
      `A declaration or remark.`,
      `To provide an official document of a proposition, especially in the UK a Statement of Special Educational Needs.`,
    ],
  },
  {
    word: `maintain`,
    wordInfo: [
      `To support (someone), to back up or assist (someone) in an action.`,
    ],
  },
  {
    word: `charge`,
    wordInfo: [
      `The amount of money levied for a service.`,
      `To assign a duty or responsibility to`,
    ],
  },
  {
    word: `popular`,
    wordInfo: [
      `A person who is popular, especially at a school.`,
      `Common among the general public; generally accepted.`,
    ],
  },
  {
    word: `traditional`,
    wordInfo: [
      `A person with traditional beliefs.`,
      `Of, relating to, or derived from tradition.`,
    ],
  },
  {
    word: `onto`,
    wordInfo: [
      `(of a function) Assuming each of the values in its codomain; having its range equal to its codomain.`,
      `Upon; on top of.`,
    ],
  },
  {
    word: `reveal`,
    wordInfo: [
      `The outer side of a window or door frame; the jamb.`,
      `To uncover; to show and display that which was hidden.`,
    ],
  },
  {
    word: `direction`,
    wordInfo: [
      `A theoretical line (physically or mentally) followed from a point of origin or towards a destination. May be relative (e.g. up, left, outbound, dorsal), geographical (e.g. north), rotational (e.g. clockwise), or with respect to an object or location (e.g. toward Boston).`,
    ],
  },
  {
    word: `weapon`,
    wordInfo: [
      `An instrument of attack or defense in combat or hunting, e.g. most guns, missiles, or swords.`,
    ],
  },
  {
    word: `employee`,
    wordInfo: [
      `An individual who provides labor to a company or another person.`,
    ],
  },
  { word: `cultural`, wordInfo: [`Pertaining to culture.`] },
  { word: `contain`, wordInfo: [`To hold inside.`] },
  {
    word: `peace`,
    wordInfo: [
      `A state of tranquility, quiet, and harmony; absence of violence. For instance, a state free from civil disturbance.`,
      `To make peace; to put at peace; to be at peace.`,
    ],
  },
  {
    word: `head`,
    wordInfo: [
      `The part of the body of an animal or human which contains the brain, mouth and main sense organs.`,
      `To be in command of. (See also head up.)`,
      `Foremost in rank or importance.`,
    ],
  },
  {
    word: `control`,
    wordInfo: [
      `Influence or authority over something.`,
      `To exercise influence over; to suggest or dictate the behavior of.`,
    ],
  },
  {
    word: `base`,
    wordInfo: [
      `Something from which other things extend; a foundation.`,
      `To give as its foundation or starting point; to lay the foundation of.`,
      `Low in height; short.`,
      `Of sound, a voice or an instrument, low in pitch or frequency.`,
    ],
  },
  {
    word: `pain`,
    wordInfo: [
      `An ache or bodily suffering, or an instance of this; an unpleasant sensation, resulting from a derangement of functions, disease, or injury by violence; hurt.`,
      `Any of various breads stuffed with a filling.`,
      `To hurt; to put to bodily uneasiness or anguish; to afflict with uneasy sensations of any degree of intensity; to torment; to torture.`,
    ],
  },
  {
    word: `apply`,
    wordInfo: [
      `To lay or place; to put (one thing to another)`,
      `Resembling apples, apple-like.`,
    ],
  },
  {
    word: `play`,
    wordInfo: [
      `Activity for amusement only, especially among the young.`,
      `To act in a manner such that one has fun; to engage in activities expressly for the purpose of recreation or entertainment.`,
    ],
  },
  {
    word: `measure`,
    wordInfo: [
      `A prescribed quantity or extent.`,
      `To ascertain the quantity of a unit of material via calculated comparison with respect to a standard.`,
    ],
  },
  {
    word: `wide`,
    wordInfo: [
      `A ball that passes so far from the batsman that the umpire deems it unplayable; the arm signal used by an umpire to signal a wide; the extra run added to the batting side's score`,
      `Having a large physical extent from side to side.`,
    ],
  },
  {
    word: `shake`,
    wordInfo: [
      `The act of shaking or being shaken; tremulous or back-and-forth motion.`,
      `To cause (something) to move rapidly in opposite directions alternatingly.`,
    ],
  },
  {
    word: `fly`,
    wordInfo: [
      `Any insect of the order Diptera; characterized by having two wings (except for some wingless species), also called true flies.`,
      `The action of flying; flight.`,
    ],
  },
  {
    word: `interview`,
    wordInfo: [
      `An official face-to-face meeting of monarchs or other important figures.`,
      `To ask questions of (somebody); to have an interview.`,
    ],
  },
  {
    word: `manage`,
    wordInfo: [
      `The act of managing or controlling something.`,
      `To direct or be in charge of.`,
    ],
  },
  {
    word: `chair`,
    wordInfo: [
      `An item of furniture used to sit on or in, comprising a seat, legs, back, and sometimes arm rests, for use by one person. Compare stool, couch, sofa, settee, loveseat and bench.`,
      `To act as chairperson at; to preside over.`,
    ],
  },
  {
    word: `fish`,
    wordInfo: [
      `A cold-blooded vertebrate animal that lives in water, moving with the help of fins and breathing with gills.`,
      `A period of time spent fishing.`,
    ],
  },
  {
    word: `particular`,
    wordInfo: [
      `A small individual part of something larger; a detail, a point.`,
      `Pertaining only to a part of something; partial.`,
    ],
  },
  {
    word: `camera`,
    wordInfo: [`A device for taking still or moving pictures or photographs.`],
  },
  {
    word: `structure`,
    wordInfo: [
      `A cohesive whole built up of distinct parts.`,
      `To give structure to; to arrange.`,
    ],
  },
  {
    word: `politics`,
    wordInfo: [
      `To engage in political activity; politick.`,
      `A methodology and activities associated with running a government, an organization, or a movement.`,
    ],
  },
  { word: `perform`, wordInfo: [`To do something; to execute.`] },
  {
    word: `bit`,
    wordInfo: [
      `A piece of metal placed in a horse's mouth and connected to the reins to direct the animal.`,
      `Bitten.`,
      `To put a bridle upon; to put the bit in the mouth of (a horse).`,
      `To cut into something by clamping the teeth.`,
    ],
  },
  {
    word: `weight`,
    wordInfo: [
      `(physical) Matter, material.`,
      `The Eucharist, now especially in Roman Catholicism.`,
    ],
  },
  {
    word: `suddenly`,
    wordInfo: [
      `Happening quickly and with little or no warning; in a sudden manner.`,
    ],
  },
  {
    word: `discover`,
    wordInfo: [`To find or learn something for the first time.`],
  },
  {
    word: `candidate`,
    wordInfo: [
      `A person who is running in an election.`,
      `To stand as a candidate for an office, especially a religious one.`,
    ],
  },
  {
    word: `top`,
    wordInfo: [
      `The highest or uppermost part of something.`,
      `To cover on the top or with a top.`,
    ],
  },
  {
    word: `production`,
    wordInfo: [`The act of producing, making or creating something.`],
  },
  {
    word: `treat`,
    wordInfo: [
      `An entertainment, outing, food, drink, or other indulgence provided by someone for the enjoyment of others.`,
      `To negotiate, discuss terms, bargain (for or with).`,
    ],
  },
  {
    word: `trip`,
    wordInfo: [
      `A journey; an excursion or jaunt`,
      `To fall over or stumble over an object as a result of striking it with one's foot`,
      `A herd or flock of sheep, goats, etc.`,
    ],
  },
  {
    word: `evening`,
    wordInfo: [
      `The time of the day between dusk and night, when it gets dark.`,
      `To make flat and level.`,
    ],
  },
  {
    word: `affect`,
    wordInfo: [
      `To influence or alter.`,
      `To make a show of; to put on a pretense of; to feign; to assume. To make a false display of.`,
    ],
  },
  {
    word: `inside`,
    wordInfo: [
      `The interior or inner part.`,
      `Of or pertaining to the inner surface, limit or boundary.`,
    ],
  },
  {
    word: `conference`,
    wordInfo: [
      `The act of consulting together formally; serious conversation or discussion; interchange of views.`,
      `To assess (a student) by one-on-one conversation, rather than an examination.`,
    ],
  },
  {
    word: `unit`,
    wordInfo: [
      `A particular, minute unit of mass, defined differently for different substances, but so that varying substances of the same general type have the property that one international unit of the one has the same effect on the human body as one international unit of the other.`,
      `Oneness, singularity, seen as a component of a whole number; a magnitude of one.`,
    ],
  },
  {
    word: `best`,
    wordInfo: [
      `The supreme effort one can make, or has made.`,
      `To surpass in skill or achievement.`,
    ],
  },
  {
    word: `style`,
    wordInfo: [
      `Senses relating to a thin, pointed object.`,
      `To design, fashion, make, or arrange in a certain way or form (style)`,
    ],
  },
  {
    word: `adult`,
    wordInfo: [
      `A fully grown human or animal.`,
      `To (cause to) be or become an adult.`,
    ],
  },
  {
    word: `worry`,
    wordInfo: [
      `A strong feeling of anxiety.`,
      `To be troubled; to give way to mental anxiety or doubt.`,
    ],
  },
  {
    word: `range`,
    wordInfo: [
      `A line or series of mountains, buildings, etc.`,
      `To travel over (an area, etc); to roam, wander.`,
    ],
  },
  {
    word: `mention`,
    wordInfo: [
      `A speaking or notice of anything, usually in a brief or cursory manner. Used especially in the phrase make mention of.`,
      `To make a short reference to something.`,
    ],
  },
  {
    word: `rather`,
    wordInfo: [`To prefer; to prefer to.`, `Prior; earlier; former.`],
  },
  {
    word: `far`,
    wordInfo: [
      `Distant; remote in space.`,
      `Spelt (a type of wheat, Triticum spelta), especially in the context of Roman use of it.`,
      `To, from or over a great distance in space, time or other extent.`,
    ],
  },
  {
    word: `deep`,
    wordInfo: [
      '(with `the`) The deep part of a lake, sea, etc.',
      `(of a physical distance) Extending far away from a point of reference, especially downwards.`,
    ],
  },
  {
    word: `front`,
    wordInfo: [
      `The foremost side of something or the end that faces the direction it normally moves.`,
      `To face (on, to); to be pointed in a given direction.`,
    ],
  },
  {
    word: `edge`,
    wordInfo: [
      `The boundary line of a surface.`,
      `To move an object slowly and carefully in a particular direction.`,
    ],
  },
  {
    word: `individual`,
    wordInfo: [
      `A person considered alone, rather than as belonging to a group of people.`,
      `Relating to a single person or thing as opposed to more than one.`,
    ],
  },
  {
    word: `specific`,
    wordInfo: [
      `A distinguishing attribute or quality.`,
      `Explicit or definite`,
    ],
  },
  {
    word: `writer`,
    wordInfo: [`A person who writes, or produces literary work.`],
  },
  {
    word: `trouble`,
    wordInfo: [
      `A distressing or dangerous situation.`,
      `To disturb, stir up, agitate (a medium, especially water).`,
    ],
  },
  {
    word: `necessary`,
    wordInfo: [
      '(usually with the definite article) A place to do the `necessary` business of urination and defecation: an outhouse or lavatory.',
      `Required, essential, whether logically inescapable or needed in order to achieve a desired result or avoid some penalty.`,
    ],
  },
  {
    word: `throughout`,
    wordInfo: [
      `Completely through, right the way through.`,
      `In every part of; all through.`,
    ],
  },
  {
    word: `challenge`,
    wordInfo: [
      `A confrontation; a dare.`,
      `To invite (someone) to take part in a competition.`,
    ],
  },
  {
    word: `fear`,
    wordInfo: [
      `A strong, uncontrollable, unpleasant emotion or feeling caused by actual or perceived danger or threat.`,
      `Able; capable; stout; strong; sound.`,
      `To feel fear about (something or someone); to be afraid of; to consider or expect with alarm.`,
    ],
  },
  {
    word: `shoulder`,
    wordInfo: [
      `The part of an animal's body between the base of the neck and forearm socket.`,
      `To push (a person or thing) using one's shoulder.`,
    ],
  },
  {
    word: `institution`,
    wordInfo: [`A custom or practice of a society or community.`],
  },
  {
    word: `middle`,
    wordInfo: [`A centre, midpoint.`, `To take a middle view of.`],
  },
  { word: `sea`, wordInfo: [`A large body of salt water.`] },
  {
    word: `dream`,
    wordInfo: [
      `Imaginary events seen in the mind while sleeping.`,
      `To see imaginary events in one's mind while sleeping.`,
    ],
  },
  {
    word: `bar`,
    wordInfo: [
      `A solid, more or less rigid object of metal or wood with a uniform cross-section smaller than its length.`,
      `To obstruct the passage of (someone or something).`,
    ],
  },
  {
    word: `beautiful`,
    wordInfo: [
      `Someone who is beautiful. Can be used as a term of address.`,
      `Attractive and possessing beauty.`,
    ],
  },
  {
    word: `property`,
    wordInfo: [
      `Something that is owned.`,
      `To invest with properties, or qualities.`,
    ],
  },
  {
    word: `instead`,
    wordInfo: [
      `In the place of something (usually mentioned earlier); as a substitute or alternative.`,
    ],
  },
  {
    word: `improve`,
    wordInfo: [
      `To make (something) better; to increase the value or productivity (of something).`,
    ],
  },
  {
    word: `stuff`,
    wordInfo: [
      `Miscellaneous items or objects; (with possessive) personal effects.`,
      `To fill by packing or crowding something into; to cram with something; to load to excess.`,
    ],
  },
  {
    word: `claim`,
    wordInfo: [
      `A demand of ownership made for something.`,
      `To demand ownership of.`,
    ],
  },
];
